// Todo texto visible de la aplicación vive aquí (app/CLAUDE.md).
/** «48», «40 y 48», «30, 40 y 48»: una lista corta de cifras dicha como se habla. */
const lista = (xs: number[]) =>
  xs.length <= 1 ? xs.join('') : `${xs.slice(0, -1).join(', ')} y ${xs[xs.length - 1]}`

export const es = {
  app: {
    nombre: 'Uniper Ops',
    lugar: 'Cozumel',
  },
  estadoOrden: {
    borrador: 'Borrador',
    confirmada: 'Confirmada',
    en_curso: 'En curso',
    cerrada: 'Cerrada',
    facturada: 'Facturada',
    cancelada: 'Cancelada',
  },
  flota: { A: 'Bus A', TB: 'Bus T', TV: 'Van T' },
  producto: {
    sencillo: 'Traslado sencillo',
    redondo: 'Traslado redondo',
    recorrido: 'Tour',
    jornada: 'Jornada dedicada',
  },
  cobranza: {
    pendiente: 'Pendiente',
    parcial: 'Pagado parcial',
    pagado: 'Pagado',
    vencido: 'Vencido',
    cancelado: 'Cancelado',
  },
  rol: {
    admin: 'Admin',
    gerencia: 'Gerencia',
    cobranza: 'Cobranza',
    operaciones: 'Operaciones',
    muelle: 'Muelle',
    operador: 'Operador',
    cliente: 'Cliente',
    despachador: 'Despachador',
  },
  confirmar: {
    motivo: 'Motivo',
    elegirMotivo: 'Elige un motivo',
    nota: 'Nota (opcional)',
    cancelar: 'Regresar',
    confirmar: 'Confirmar',
  },
  estados: {
    vacioTitulo: 'Aún no hay nada aquí',
    errorTitulo: 'No se pudo cargar',
    reintentar: 'Reintentar',
    soloLectura: 'Solo lectura',
  },
  fecha: {
    elegirFecha: 'Elegir fecha',
    elegirPeriodo: 'Elegir periodo',
    elegirHora: 'Elegir hora',
    hoy: 'Hoy',
    manana: 'Mañana',
    primeraQuincena: '1.ª quincena',
    segundaQuincena: '2.ª quincena',
    esteMes: 'Este mes',
    mesAnterior: 'Mes anterior',
    mesSiguiente: 'Mes siguiente',
    eligeFin: 'Elige el último día',
    eligeFinMax: (n: number) => `Elige el último día. Máximo ${n} días.`,
    horaInvalida: 'Hora no válida. Ejemplos: 845, 17:30',
    horas: 'Hora',
    minutos: 'Minutos',
    placeholderHora: 'hh:mm',
  },
  acceso: {
    marca: 'La operación del día, en una sola pantalla.',
    marcaDetalle:
      'Órdenes de servicio, rol de unidades y operadores, y cobranza quincenal por agencia.',
    lema: 'Calidad, confort y seguridad',
    titulo: 'Iniciar sesión',
    subtitulo: 'Usa el correo con el que te invitaron.',
    correo: 'Correo',
    contrasena: 'Contraseña',
    mostrar: 'Mostrar contraseña',
    ocultar: 'Ocultar contraseña',
    recordar: 'Mantener sesión',
    olvide: 'Olvidé mi contraseña',
    entrar: 'Entrar',
    o: 'o',
    enlace: 'Enviarme un enlace de acceso',
    nota: 'Acceso solo para personal de Uniper. Los roles los asigna un Admin.',
    correoEjemplo: 'nombre@unipercozumel.com',
    enlaceEnviado: 'Si el correo tiene acceso, te llegó un enlace para entrar.',
    recuperacionEnviada:
      'Si el correo tiene acceso, te llegó un enlace para cambiar tu contraseña.',
    nuevaTitulo: 'Define tu contraseña',
    nuevaSubtitulo: 'Mínimo 10 caracteres, con letras y números.',
    nueva: 'Contraseña nueva',
    confirmar: 'Confírmala',
    guardar: 'Guardar y entrar',
    enlaceVencido: 'El enlace ya no es válido. Pide uno nuevo.',
    volverAEntrar: 'Volver a iniciar sesión',
    sinAccesoTitulo: 'Tu acceso no está activo',
    sinAccesoTexto: 'Pídele a un Admin de Uniper que revise tu usuario.',
    salir: 'Salir',
    errores: {
      correoRequerido: 'Escribe tu correo',
      correoInvalido: 'Ese correo no es válido',
      contrasenaRequerida: 'Escribe tu contraseña',
      contrasenaCorta: 'Mínimo 10 caracteres',
      contrasenaLetrasNumeros: 'Usa letras y números',
      noCoinciden: 'No coinciden',
      contrasenaDebil:
        'La contraseña necesita mínimo 10 caracteres, con al menos una letra y un número.',
      credenciales: 'Correo o contraseña incorrectos',
      demasiados: 'Demasiados intentos. Espera unos minutos y vuelve a intentar.',
      red: 'No hay conexión. Revisa tu internet.',
    },
  },
  configuracion: {
    titulo: 'Configuración',
    migas: 'Administración',
    pestanas: { general: 'General', usuarios: 'Usuarios y roles' },
    guardar: 'Guardar cambios',
    guardado: 'Cambios guardados',
    sinCambios: 'No hay cambios por guardar',
    soloAdmin: 'Solo un Admin cambia la configuración.',
    p: {
      cobro: 'Cobro',
      iva: 'IVA (%)',
      ivaAyuda: 'Las tarifas se capturan sin IVA.',
      horasRecorrido: 'Horas incluidas en un tour',
      horaExtra: 'Cobrar hora extra en tours',
      horaExtraAyuda: 'Ajuste manual en la orden. Apagado, el exceso solo avisa.',
      operacion: 'Operación del día',
      margenRegreso: 'Aviso de regreso justo (min)',
      margenRegresoAyuda: 'Minutos entre el regreso y la salida del barco para avisar.',
      holgura: 'Holgura entre tramos (min)',
      holguraAyuda: 'Tiempo mínimo entre un servicio y otro en la misma unidad.',
      trayecto: 'Trayecto en la isla (min)',
      trayectoAyuda:
        'Lo que tarda un traslado cuando el servicio no trae duración. Cada orden lo copia y se puede ajustar.',
      ventanaTablero: 'Horario del tablero',
      desde: 'Desde',
      hasta: 'Hasta',
      rotacion: 'Rotación de operadores contada por',
      rotacionOpciones: { semana: 'Semana', quincena: 'Quincena', mes: 'Mes' },
      clonacion: 'Clonación',
      topeOrdenes: 'Máximo de órdenes por clonación',
      topeDias: 'Máximo de días por clonación',
      campo: 'Clientes con jornadas (tramo 2)',
      disputa: 'Horas para revisar el día (por defecto)',
      disputaAyuda: '0 = sin plazo, pasa directo a Cobranza. Se ajusta por cliente.',
      confirmarIvaTitulo: 'Cambiar el IVA',
      confirmarIva: (antes: string, despues: string) =>
        `El IVA pasa de ${antes} % a ${despues} %. Las órdenes y Recibos ya creados conservan su IVA; solo las nuevas usan la tasa nueva.`,
      confirmarIvaBoton: 'Cambiar IVA',
      ultimoCambio: 'Último cambio',
      recibo: 'Datos de Uniper en el Recibo',
      reciboAyuda:
        'Salen en el PDF de cada Recibo. Un Recibo ya emitido conserva los datos con los que se emitió.',
      razonSocial: 'Razón social',
      rfc: 'RFC',
      domicilio: 'Domicilio',
      contacto: 'Teléfono y correo',
      datosDeposito: 'Datos para depósito (banco y CLABE)',
    },
    s: {
      orden: 'Órdenes de servicio',
      recibo: 'Recibos',
      codigo: 'Serie',
      siguiente: 'Siguiente folio',
      ultimo: 'Último usado',
      activa: 'Activa',
      enUso: 'En uso',
      activar: 'Activar',
      nueva: 'Nueva serie',
      tipo: 'Tipo',
      codigoAyuda: 'Letras mayúsculas, sin espacios (ej. YM).',
      crear: 'Crear serie',
      confirmarActivarTitulo: 'Activar serie',
      confirmarActivar: (codigo: string, siguiente: number) =>
        `Desde ahora los folios nuevos usan la serie ${codigo}, empezando en ${siguiente}. La serie anterior deja de numerar; sus folios no cambian.`,
      cambiarSiguiente: 'Cambiar siguiente folio',
      cambiar: 'Cambiar',
      noBaja: (ultimo: number) => `No puede ser menor o igual a ${ultimo}, el último usado.`,
      nota: 'Antes de salir en vivo: borra los datos de prueba, crea la serie YM con el folio que sigue al papel y actívala.',
    },
    u: {
      invitar: 'Invitar usuario',
      nombre: 'Nombre',
      correo: 'Correo',
      rol: 'Rol',
      estado: 'Estado',
      ultimoAcceso: 'Último acceso',
      nunca: 'Nunca',
      activo: 'Activo',
      inactivo: 'Inactivo',
      pendiente: 'Invitación sin aceptar',
      desactivar: 'Desactivar',
      reactivar: 'Reactivar',
      enviar: 'Enviar invitación',
      invitado: 'Invitación enviada',
      confirmarDesactivarTitulo: 'Desactivar usuario',
      confirmarDesactivar: (n: string) =>
        `${n} pierde el acceso en su siguiente clic, aunque tenga la sesión abierta. Su historial se conserva.`,
      rolesConAlcance:
        'Operador, Cliente y Despachador se habilitan cuando existan sus catálogos (operadores y agencias).',
      muelle: 'Muelle',
      muelleAyuda: 'Solo verá las salidas y alertas de este muelle.',
      rolCambiado: 'Rol actualizado',
      tu: 'Tú',
    },
    errores: {
      numero: 'Escribe un número',
      rango: (a: number, b: number) => `Entre ${a} y ${b}`,
      ventana: 'La hora de inicio debe ser antes que la de fin',
      codigo: 'Solo letras mayúsculas, de 1 a 6',
      ultimoAdmin: 'Debe quedar al menos un Admin activo',
      nombre: 'Escribe el nombre',
      muelle: 'Elige el muelle',
      largo: (n: number) => `Máximo ${n} caracteres`,
      rfc: 'RFC no válido',
    },
  },
  catalogos: {
    titulo: 'Catálogos',
    pestanas: {
      agencias: 'Agencias',
      flota: 'Flota y unidades',
      operadores: 'Operadores',
      lugares: 'Lugares',
      barcos: 'Barcos y navieras',
    },
    buscar: 'Buscar',
    nuevo: 'Nuevo',
    editar: 'Editar',
    guardar: 'Guardar',
    desactivar: 'Desactivar',
    reactivar: 'Reactivar',
    inactivo: 'Inactivo',
    activos: 'Activos',
    todos: 'Todos',
    sinResultados: 'Nada coincide con la búsqueda',
    duplicado: 'Ya existe uno con ese nombre',
    l: {
      nuevo: 'Nuevo lugar',
      editar: 'Editar lugar',
      nombre: 'Nombre',
      tipo: 'Tipo',
      tipos: { muelle: 'Muelle', punto: 'Punto de tour', hotel: 'Hotel', otro: 'Otro' },
      conPersonal: 'Muelle con personal de Uniper',
      conPersonalAyuda: 'Solo los 4 muelles donde hay personal de Muelle.',
      alias: 'Otros nombres (alias)',
      aliasAyuda:
        'Como aparece en correos o en el rol, por ejemplo «P. Langosta». Enter para agregar.',
      agregarAlias: 'Agregar alias',
      quitarAlias: (a: string) => `Quitar ${a}`,
      buscarAyuda: 'Nombre o alias',
      vacio: 'Aún no hay lugares',
      confirmarDesactivar: (n: string) =>
        `${n} deja de aparecer al capturar servicios nuevos. Lo ya registrado no cambia.`,
      personal: 'Con personal',
    },
    b: {
      navieras: 'Navieras',
      barcos: 'Barcos',
      nuevaNaviera: 'Nueva naviera',
      agregarNaviera: 'Agregar',
      nuevoBarco: 'Nuevo barco',
      editarBarco: 'Editar barco',
      nombre: 'Nombre',
      naviera: 'Naviera',
      sinNaviera: 'Sin naviera',
      vacioBarcos: 'Aún no hay barcos',
      vacioNavieras: 'Aún no hay navieras',
      nota: 'El muelle cambia en cada arribo, por eso no se guarda en el barco.',
    },
    f: {
      nueva: 'Nueva unidad',
      editar: 'Editar unidad',
      numero: 'Número económico',
      numeroAyuda: 'Con el prefijo de su flota, por ejemplo A-07 o T-49.',
      flota: 'Flota',
      tipo: 'Tipo',
      tipos: { bus: 'Bus', van: 'Van', open_top: 'Open Top' },
      capacidad: 'Capacidad',
      titular: 'Operador titular',
      sinTitular: 'Sin titular',
      estado: 'Estado',
      estados: { activa: 'Activa', taller: 'En taller', baja: 'Baja' },
      propietario: 'Propietario',
      salidas: 'Salidas del periodo',
      uniper: 'Uniper',
      unidades: (n: number) => `${n} ${n === 1 ? 'unidad' : 'unidades'}`,
      lugares: (n: number) => `${n} lugares`,
      todas: 'Todas',
      vacio: 'Aún no hay unidades',
      titularAyuda:
        'Solo operadores de la misma flota. Si ya era titular de otra unidad, esa queda sin titular.',
    },
    o: {
      nuevo: 'Nuevo operador',
      editar: 'Editar operador',
      nombre: 'Nombre',
      flota: 'Flota',
      telefono: 'Teléfono',
      unidad: 'Unidad titular',
      sinUnidad: 'Sin unidad',
      vacio: 'Aún no hay operadores',
      regla: 'Cada operador solo maneja unidades de su flota.',
      ayuda:
        'Cada operador pertenece a una flota y solo maneja unidades de esa flota. Las salidas son las del periodo de rotación.',
      todos: 'Todos',
      salidas: 'Salidas',
      sobre: (n: number) => `+${n} sobre el promedio`,
      bajo: (n: number) => `−${n} bajo el promedio`,
      enPromedio: 'en el promedio',
      activoEtiqueta: (nombre: string) => `Activo: ${nombre}`,
      filtroFlota: 'Flota',
      confirmarDesactivar: (n: string) =>
        `${n} deja de aparecer para asignar servicios. Su historial se conserva.`,
      licencia: 'Vigencia de la licencia',
      licenciaAyuda:
        'Último día en que la licencia vale. Con la licencia vencida no se le asignan servicios posteriores.',
      licenciaHasta: (f: string) => `Licencia vigente hasta ${f}`,
      licenciaSin: 'Licencia sin capturar',
      licenciaVencida: 'Licencia vencida',
      licenciaVence: (dias: number) =>
        dias === 0 ? 'Vence hoy' : dias === 1 ? 'Vence mañana' : `Vence en ${dias} días`,
    },
    a: {
      nuevo: 'Nueva agencia',
      editar: 'Editar agencia',
      ver: 'Ver',
      servicios: 'Servicios',
      datos: 'Datos de operación',
      nombre: 'Nombre',
      contacto: 'Contacto',
      telefono: 'Teléfono',
      correo: 'Correo de operación',
      cupon: 'Cobra con cupón',
      cuponAyuda: 'Apágalo si el cliente da conformidad del día en vez de cupón (Kuza).',
      cobro: 'Se cobra con',
      conCupon: 'Cupón',
      conConformidad: 'Conformidad',
      cobranza: 'Datos de cobranza',
      cobranzaAyuda: 'Solo los ven Admin, Gerencia y Cobranza.',
      razonSocial: 'Razón social',
      rfc: 'RFC',
      correoCobranza: 'Correo de cobranza',
      diasCredito: 'Días de crédito',
      credito: (n: number) => `${n} días`,
      vacio: 'Aún no hay agencias',
      buscar: 'Buscar agencia',
      lista: 'Agencias',
      activa: 'Activa',
      inactiva: 'Inactiva',
      nServicios: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
      sinServicios: 'Sin servicios',
      editarDatos: 'Editar datos',
      pestanaDatos: 'Datos y fiscales',
      pestanaServicios: (n: number) => `Servicios de cliente · ${n}`,
      verOrdenes: 'Órdenes',
      tel: 'Teléfono',
      sinDato: '—',
      sinAgenciaServicios:
        'Esta agencia no tiene servicios: en la captura aparece este aviso con el atajo para crear el primero.',
      soloLectura: 'Solo lectura para tu rol.',
      confirmarDesactivar: (n: string) =>
        `${n} deja de aparecer al capturar órdenes nuevas. Sus órdenes y recibos no cambian.`,
    },
    s: {
      titulo: (agencia: string) => `Servicios de ${agencia}`,
      volver: 'Agencias',
      ayuda: (agencia: string) =>
        `Las plantillas que usa ${agencia}. Una orden nueva hereda todo de aquí.`,
      servicios: 'Servicios',
      nuevo: 'Nuevo servicio',
      editar: 'Editar servicio',
      vacio: 'Esta agencia aún no tiene servicios',
      vacioAyuda:
        'Da de alta lo que se le presta (por ejemplo XTrail, Traslado redondo, 40 lugares) para no capturar cada orden desde cero.',
      producto: 'Producto',
      ayudaProducto: {
        sencillo: 'De A a B en un tramo. También el «solo regreso».',
        redondo: 'Ida y regreso. La unidad queda libre entre los dos tramos.',
        recorrido: 'Sale y vuelve al mismo lugar pasando por paradas. Hasta 5 h con tarifa fija.',
        jornada: 'Unidad y operador a disposición del cliente todo el día (tramo 2).',
      },
      antetitulo: (agencia: string) => `${agencia} · Servicio de cliente`,
      productoCorto: {
        sencillo: 'A→B · Traslado sencillo',
        redondo: 'A→B→A · Traslado redondo',
        recorrido: 'A→paradas→A · Tour',
        jornada: 'Jornada dedicada',
      },
      referencia: 'Referencia del cliente',
      referenciaAyuda: 'Como la nombra la agencia: XTrail, City Tour, OP.',
      origen: 'Origen',
      destino: 'Destino',
      destinoOpcional: 'Destino (opcional)',
      destinoAyuda: 'Déjalo en blanco si la agencia no siempre dice a dónde va.',
      porDefinir: 'por definir',
      paradasAyuda: 'Opcional: agrega las paradas si siempre son las mismas.',
      elegir: 'Elige un lugar',
      ruta: 'Ruta',
      paradas: 'Paradas',
      agregarParada: 'Agregar parada',
      subir: 'Subir',
      bajar: 'Bajar',
      quitar: 'Quitar',
      duracion: 'Duración (min)',
      desfase: 'Espera en el destino (min)',
      desfaseAyuda:
        'Cuánto tiempo se queda la agencia en el destino antes del regreso. Con esto se calcula la hora de regreso de cada orden, y ahí se puede ajustar.',
      capacidad: 'Lugares contratados',
      sugeridas: 'Capacidades de la flota',
      flota: 'Flota preferida',
      tipoVehiculo: 'Tipo de vehículo',
      tipoVehiculoAyuda:
        'Opcional. Dice con qué se presta el servicio; no impide asignar otra unidad.',
      tipoUnicoAyuda: (flota: string) => `La flota ${flota} solo tiene este tipo de vehículo.`,
      cualquiera: 'Cualquiera',
      tarifa: 'Tarifa',
      tarifaAyuda: 'Sin IVA. Solo Admin la cambia; un cambio aplica desde la fecha que elijas.',
      modo: 'Se cobra',
      modos: { por_lugar: 'Por lugar', por_servicio: 'Por servicio' },
      monto: 'Monto sin IVA',
      desde: 'Vigente desde',
      vigente: 'Vigente',
      sinTarifa: 'Sin tarifa',
      totalUnidad: 'Total por unidad',
      totalAyuda: 'Lo calcula el sistema al guardar.',
      confirmarDesactivar: (n: string) =>
        `${n} deja de aparecer al capturar órdenes. Las órdenes hechas no cambian.`,
      errores: {
        referencia: 'Escribe cómo lo llama la agencia',
        lugar: 'Elige el lugar',
        mismoLugar: 'Origen y destino deben ser distintos',
        paradas: 'Agrega al menos una parada',
        minutos: 'Minutos entre 5 y 900',
        capacidad: 'Entre 1 y 80',
        monto: 'Monto no válido',
      },
    },
    errores: {
      rfc: 'RFC de 12 o 13 caracteres, en mayúsculas',
      correo: 'Correo no válido',
      dias: 'Entre 0 y 120',
      nombre: 'Escribe el nombre',
      largo: 'Máximo 80 caracteres',
      numero: 'Formato: letras de la flota, guion y número (A-07)',
      capacidad: 'Entre 1 y 80',
      telefono: 'Solo números, de 7 a 20',
      licencia: 'Indica hasta cuándo vale la licencia',
    },
  },
  ordenes: {
    titulo: 'Órdenes',
    migas: 'Operación',
    encabezado: 'Órdenes de servicio',
    ayuda: 'Busca, confirma, imprime y clona sin entrar a cada orden.',
    nueva: 'Nueva orden',
    vacio: 'No hay órdenes con estos filtros',
    vacioAyuda: 'Cambia la fecha o limpia los filtros. Para crear una, usa «Nueva orden».',
    vacioTarjeta: 'No hay órdenes en esta tarjeta',
    vacioTarjetaAyuda: 'Elige «Todas» para ver las demás órdenes de estas fechas.',
    sinFolio: 'Borrador',
    porDefinir: 'Por definir',
    sinTarifa: 'Sin tarifa',
    fecha: {
      etiqueta: 'Fecha',
      atajo: { hoy: 'Hoy', manana: 'Mañana', semana: 'Esta semana' },
      elegir: 'Elegir fechas',
      diasPasados: 'Días pasados sin cerrar',
      todasLasFechas: 'Buscando en todas las fechas',
    },
    /** Cómo se nombra el periodo en la línea de la tarjeta «Todas». */
    periodo: {
      busqueda: 'en todas las fechas',
      hoy: 'hoy',
      manana: 'mañana',
      semana: 'esta semana',
      rango: (desde: string, hasta: string) => (desde === hasta ? desde : `${desde} al ${hasta}`),
    },
    tarjetas: 'Filtrar por lo que falta',
    tarjeta: {
      todas: 'Todas',
      sin_unidad: 'Sin unidad',
      por_confirmar: 'Por confirmar',
      por_imprimir: 'Sin imprimir',
      por_cerrar: 'Por cerrar',
    },
    linea: {
      sinUnidad: (n: number) => (n > 0 ? 'les falta unidad u operador' : 'todas tienen unidad'),
      porConfirmar: (n: number) => (n > 0 ? 'en borrador, sin folio' : 'nada pendiente'),
      porImprimir: (n: number, futuro: boolean) =>
        n === 0 ? 'todas impresas' : futuro ? 'normal hasta la tarde' : 'imprímelas antes de salir',
      porCerrar: (n: number) => (n > 0 ? 'de días pasados' : 'nada pendiente'),
    },
    siguiente: {
      titulo: 'Siguiente paso:',
      confirmar: (n: number, de: number) =>
        n === de
          ? `${n === 1 ? 'La orden sigue' : `Las ${n} órdenes siguen`} en borrador. Confírmalas para que tengan folio.`
          : `${n} de ${de} órdenes siguen en borrador. Confírmalas para que tengan folio.`,
      verConfirmar: (n: number) => (n === 1 ? 'Ver la que falta' : `Ver las ${n} por confirmar`),
      imprimir: (asignadas: number, de: number) =>
        de === 1
          ? 'La orden tiene unidad y operador. Imprímela para entregarla al operador.'
          : asignadas === de
            ? 'Todas tienen unidad y operador. Imprímelas para entregarlas a los operadores.'
            : asignadas === 1
              ? `1 de ${de} órdenes ya tiene unidad y operador. Imprímela para entregarla al operador.`
              : `${asignadas} de ${de} órdenes ya tienen unidad y operador. Imprímelas para entregarlas a los operadores.`,
      imprimirLas: (n: number) => (n === 1 ? 'Imprimir la que está lista' : `Imprimir las ${n}`),
      tope: (n: number) => `Se mandan las primeras ${n}; repite para las demás.`,
      resolver: (n: number) => (n === 1 ? 'Resolver la que falta' : `Resolver las ${n} que faltan`),
      asignar: (n: number, de: number) =>
        `${n} de ${de} órdenes no tienen unidad u operador. Asígnalas para poder imprimirlas.`,
      listo: (de: number) =>
        de === 1
          ? 'La orden tiene unidad, operador y su hoja impresa al día.'
          : `Las ${de} órdenes tienen unidad, operador y su hoja impresa al día.`,
      porCerrar: (n: number) =>
        n === 1
          ? 'Un servicio de días pasados sigue sin cerrar. Ciérralo en el Cierre del día.'
          : `${n} servicios de días pasados siguen sin cerrar. Ciérralos en el Cierre del día.`,
      irCierre: 'Ir al Cierre del día',
      errorIds: 'No se pudieron traer las órdenes para imprimir',
    },
    filtros: {
      periodo: 'Periodo',
      agencia: 'Cliente',
      todasAgencias: 'Todos los clientes',
      producto: 'Producto',
      todosProductos: 'Todos los productos',
      buscar: 'Buscar por referencia o folio',
      buscarEjemplo: 'Busca por referencia o folio (XTrail, UO-98…)',
      estado: 'Estado',
      todosEstados: 'Todos los estados',
      flota: 'Flota',
      todasFlotas: 'Todas las flotas',
      limpiar: 'Limpiar filtros',
    },
    /** R-26: la búsqueda no recorre el historial entero ni corta en silencio. */
    busqueda: {
      minimo:
        'Escribe al menos 3 letras para buscar. Un folio, como 98 o UO-98, sí se busca completo.',
      resultados: (q: string) =>
        `Resultados de «${q}» en todas las fechas, los más recientes primero.`,
      topeTitulo: 'Hay muchas coincidencias',
      tope: (n: number) =>
        `Se muestran las ${n.toLocaleString('es-MX')} más recientes. Escribe más del nombre o filtra por cliente para afinar.`,
    },
    periodoRecortado: {
      titulo: 'El periodo se acortó a 92 días',
      ayuda:
        'Esta pantalla muestra hasta 92 días a la vez. Para encontrar una orden de otra fecha, búscala por folio o referencia.',
    },
    horario: {
      sale: (h: string) => `Sale ${h}`,
      regresa: (h: string) => `regresa ${h}`,
    },
    pax: {
      de: (cap: number) => `de ${cap}`,
      contratados: (pax: number, cap: number) => `${pax} de ${cap} contratados`,
      masDeLoContratado: 'más de lo contratado',
      sinPax: (cap: number) => `Sin pax · ${cap} lugares`,
      ayuda: 'Lleva más pasajeros que los lugares contratados. No bloquea; se corrige en Editar.',
    },
    asignarUnidad: 'Asignar unidad',
    asignarUnidadDe: (folio: string) => `Asignar unidad a ${folio}`,
    asignarOperador: 'Asignar operador',
    asignarOperadorDe: (folio: string) => `Asignar operador a ${folio}`,
    sinUnidad: 'Sin unidad',
    sinOperador: 'Sin operador',
    impresion: {
      sin: 'Sin imprimir',
      impresa: (v: number) => `Impresa v${v}`,
      reimprimir: (v: number) => `Impresa v${v} · reimprimir`,
    },
    col: {
      seleccionar: (folio: string) => `Seleccionar ${folio}`,
      seleccionarPagina: 'Seleccionar las órdenes de esta página',
      folio: 'Folio',
      cliente: 'Cliente y servicio',
      horario: 'Horario',
      pax: 'Pasajeros en lugares contratados',
      unidad: 'Unidad y operador',
      estado: 'Estado',
      total: 'Total',
      acciones: 'Acciones',
    },
    fila: {
      imprimir: 'Imprimir',
      imprimirDe: (folio: string) => `Imprimir ${folio}`,
      mas: 'Más',
      masDe: (folio: string) => `Más acciones de ${folio}`,
      ver: 'Ver orden',
      clonar: 'Clonar a otra fecha',
      cancelar: 'Cancelar…',
    },
    pagina: {
      resumen: (desde: number, hasta: number, total: number) =>
        `${desde} a ${hasta} de ${total.toLocaleString('es-MX')}`,
      anterior: 'Anterior',
      siguiente: 'Siguiente',
    },
    lote: {
      barra: 'Acciones con las órdenes seleccionadas',
      seleccionadas: (n: number) => (n === 1 ? '1 seleccionada' : `${n} seleccionadas`),
      quitar: 'Quitar selección',
      /** Etiqueta del botón: si la acción toca menos de las elegidas, dice cuántas. */
      parcial: (accion: string, n: number, de: number) =>
        n === de
          ? accion
          : accion.endsWith('…')
            ? `${accion.slice(0, -1)} ${n} de ${de}…`
            : `${accion} ${n} de ${de}`,
      confirmar: 'Confirmar',
      imprimir: 'Imprimir',
      clonar: 'Clonar a otra fecha',
      cancelar: 'Cancelar…',
      omite: {
        confirmar: (n: number) =>
          n === 1
            ? 'Confirmar omite 1 que ya no es borrador.'
            : `Confirmar omite ${n} que ya no son borradores.`,
        imprimir: (n: number) =>
          n === 1
            ? 'Imprimir omite 1: borradores y canceladas no llevan hoja.'
            : `Imprimir omite ${n}: borradores y canceladas no llevan hoja.`,
        clonar: (n: number) =>
          n === 1 ? 'Clonar omite 1 cancelada.' : `Clonar omite ${n} canceladas.`,
        cancelar: (n: number) =>
          n === 1
            ? 'Cancelar omite 1: solo se cancelan confirmadas o en curso.'
            : `Cancelar omite ${n}: solo se cancelan confirmadas o en curso.`,
      },
      ninguna: 'Ninguna de las seleccionadas admite estas acciones.',
      confirmadas: (n: number) => (n === 1 ? '1 orden confirmada' : `${n} órdenes confirmadas`),
      canceladas: (n: number) => (n === 1 ? '1 orden cancelada' : `${n} órdenes canceladas`),
      errorConfirmar: 'No se pudieron confirmar',
      errorCancelar: 'No se pudieron cancelar',
      cancelarTitulo: 'Cancelar órdenes',
      cancelarImpacto: (n: number) =>
        n === 1
          ? 'Se cancela 1 orden. No genera cargo y su folio se conserva.'
          : `Se cancelan ${n} órdenes. No generan cargo y sus folios se conservan.`,
      cancelarOmitidas: (n: number) =>
        n === 1
          ? 'Otra de las seleccionadas no se cancela porque no está confirmada ni en curso.'
          : `Otras ${n} de las seleccionadas no se cancelan porque no están confirmadas ni en curso.`,
      cancelarConfirmar: 'Cancelar órdenes',
      motivoCancelacion: 'Cancelación',
      motivoNoShow: 'No show',
    },
    totalSoloDinero: 'La columna Total solo la ven Admin, Gerencia y Cobranza.',
  },
  imprimir: {
    titulo: 'Imprimir órdenes',
    // Nombre que propone «Guardar como PDF»: el navegador lo toma del título de la página.
    archivo: (folios: string[]) =>
      folios.length === 1 ? folios[0]! : `${folios[0]} a ${folios[folios.length - 1]}`,
    volver: 'Volver',
    cuenta: (n: number) => (n === 1 ? '1 orden' : `${n} órdenes`),
    ayuda:
      'Al imprimir se registra una versión nueva de cada orden y la hoja dice cuál es. Si la orden cambia después, avisará que hay que reimprimirla.',
    imprimir: (n: number) => (n === 1 ? 'Imprimir 1 hoja' : `Imprimir ${n} hojas`),
    registrando: 'Registrando…',
    vacio: 'No hay órdenes que imprimir',
    vacioAyuda: 'Solo se imprimen órdenes confirmadas, en curso o cerradas.',
    omitidas: (n: number) =>
      n === 1
        ? 'Se dejó fuera 1 orden que no se imprime (borrador o cancelada).'
        : `Se dejaron fuera ${n} órdenes que no se imprimen (borrador o cancelada).`,
    errorCarga: 'No se pudo cargar la impresión',
    error: 'No se pudo registrar la impresión',
    registrada: 'Impresión registrada',
    sinPermiso: 'Solo Admin y Operaciones imprimen.',
    vistaPrevia: (v: number) => `Vista previa · se imprimirá como v${v}`,
    boton: 'Imprimir',
    reimprimir: (v: number) => `Reimprimir v${v}`,
    botonCantidad: (n: number) => `Imprimir (${n})`,
    botonFila: (folio: string) => `Imprimir ${folio}`,
    pendientes: (n: number) => `Imprimir órdenes · ${n}`,
    hoja: {
      titulo: 'ORDEN DE SERVICIO',
      cozumel: 'Cozumel',
      folio: 'FOLIO',
      impresa: (v: number, cuando: string, quien: string | null) =>
        `Impresa v${v} · ${cuando}${quien ? ` · ${quien}` : ''}`,
      origen: 'LUGAR DE ORIGEN',
      destino: 'LUGAR DE DESTINO',
      barco: 'BARCO',
      agencia: 'CLIENTE O AGENCIA',
      servicio: 'SERVICIO',
      unidad: 'UNIDAD',
      inicio: 'HORA DE INICIO',
      pax: 'No. DE PASAJEROS',
      termino: 'HORA DE TÉRMINO',
      fecha: 'FECHA',
      operador: 'OPERADOR',
      guia: 'GUÍA',
      porAsignar: 'Por asignar',
      sinDato: '—',
      bitacora: 'BITÁCORA DEL SERVICIO',
      colSalida: 'HORA SALIDA CON PASAJEROS',
      colLugarN: [
        '1er LUGAR DE VISITA Y HORA',
        '2do LUGAR DE VISITA Y HORA',
        '3er LUGAR DE VISITA Y HORA',
      ],
      colTermino: 'LUGAR Y HORA DE TÉRMINO',
      colDuracion: 'DURACIÓN DEL SERVICIO',
      prog: (h: string) => `Prog. ${h}`,
      real: 'Real:',
      regreso: (lugar: string) => `Regreso a ${lugar}`,
      cupon: 'NÚMERO DE CUPÓN DE LA AGENCIA',
      conformidad: 'REPORTE DE CONFORMIDAD',
      objetos: 'Objetos olvidados en la unidad:',
      revisaron: 'El conductor y el guía revisaron la unidad:',
      si: 'Sí',
      no: 'No',
      siendoLas: 'Siendo las',
      horasDelDia: 'horas del día',
      encontrandose: 'encontrándose:',
      descripcion: 'Descripción del objeto(s):',
      observaciones: 'Observaciones:',
      cliente: 'CLIENTE',
      conductor: 'CONDUCTOR DE UNIPER',
      nombreFirma: 'Nombre y firma',
      qr: 'Código QR de la orden',
      contacto: 'Tel. (987) 872 21 10 · unipercozumel.com · contacto@unipercozumel.com',
      direccion:
        'Av. 8 de Octubre S/N con Av. Claudio Canto Anduze, Zona Industrial, Cozumel Q. Roo · RFC UPT900726867',
    },
  },
  imprimirRol: {
    titulo: 'Imprimir rol',
    ayuda:
      'El rol sale de las órdenes del día, una hoja por flota. Al imprimir se registra una versión nueva del rol y la hoja dice cuál es.',
    imprimir: 'Imprimir rol',
    registrando: 'Registrando…',
    registrada: (v: number) => `Rol v${v} registrado`,
    /** R-26: la hoja saldría incompleta; se dice antes de imprimir. */
    tope: 'Este día tiene más órdenes de las que caben en la hoja y el rol saldría incompleto. Revisa todas en Órdenes antes de imprimir.',
    error: 'No se pudo registrar la impresión del rol',
    errorCarga: 'No se pudo cargar el rol',
    sinPermiso: 'Solo Admin y Operaciones imprimen.',
    vacio: 'No hay servicios que imprimir este día',
    vacioAyuda: 'El rol lleva los servicios confirmados, en curso o cerrados del día.',
    volverTablero: 'Volver al tablero',
    hojas: (n: number) => (n === 1 ? '1 hoja' : `${n} hojas`),
    borradores: (n: number) =>
      n === 1
        ? '1 borrador no sale en el rol. Confírmalo y vuelve a imprimir.'
        : `${n} borradores no salen en el rol. Confírmalos y vuelve a imprimir.`,
    sinOperadorAviso: (n: number) =>
      n === 1
        ? '1 servicio sale sin unidad u operador. Queda resaltado en la hoja.'
        : `${n} servicios salen sin unidad u operador. Quedan resaltados en la hoja.`,
    ultimo: (v: number, hora: string) => `Último impreso: v${v} · ${hora}`,
    nunca: 'Este día aún no se imprime',
    vistaPrevia: (v: number) => `Vista previa · se imprimirá como v${v}`,
    hoja: {
      titulo: (dia: string) => `ROL DEL DÍA · ${dia}`,
      impreso: (v: number, cuando: string, quien: string | null, servicios: number) =>
        `Generado de las órdenes · v${v} · impreso ${cuando}${quien ? ` por ${quien}` : ''} · ${servicios} ${servicios === 1 ? 'servicio' : 'servicios'}`,
      previa: (v: number, servicios: number) =>
        `Generado de las órdenes · vista previa v${v} · ${servicios} ${servicios === 1 ? 'servicio' : 'servicios'}`,
      barcos: (lista: string) => `Barcos: ${lista}`,
      /** Para el renglón que no regresa: corto, la columna es angosta. */
      sinRegreso: 'Sencillo',
      sinFlota: 'Sin flota',
      continua: (dia: string, v: number) => `${dia} · v${v}`,
      col: {
        unidad: 'UNIDAD',
        operador: 'OPERADOR',
        lugar: 'LUGAR',
        hora: 'HORA',
        regreso: 'REGRESO',
        barco: 'BARCO',
        folio: 'FOLIO',
        agencia: 'AGENCIA',
        pax: 'PAX',
      },
      sinUnidad: 'SIN UNIDAD',
      sinOperador: 'SIN OPERADOR',
      sinDato: '—',
      pie: 'Si una orden cambia después de esta hora, se reimprime con nueva versión.',
    },
  },
  /** Incidentes de una unidad (R-23): se ligan a la unidad y a la fecha del evento; la orden es opcional. */
  incidentes: {
    titulo: 'Incidentes',
    ayuda:
      'Lo que pasó con una unidad un día: un objeto olvidado, un daño, una queja. Se registra aunque el día ya esté cerrado y no se edita después.',
    registrar: 'Registrar incidente',
    soloVer: 'Solo Admin y Operaciones registran incidentes.',
    errorCarga: 'No se pudieron cargar los incidentes',
    vacio: 'No hay incidentes con estos filtros',
    vacioAyuda: 'Cuando algo pase con una unidad, regístralo aquí.',
    /** R-26: la lista trae los 300 más recientes; el total sale de la base. */
    tope: 'Ves los más recientes. Filtra por unidad o categoría para llegar a los demás.',
    filtros: {
      unidad: 'Unidad',
      todasUnidades: 'Todas las unidades',
      categoria: 'Tipo',
      todos: 'Todos los tipos',
    },
    categorias: {
      objeto_olvidado: 'Objeto olvidado',
      dano: 'Daño a la unidad',
      accidente: 'Accidente',
      queja: 'Queja de un pasajero',
      otro: 'Otro',
    },
    col: {
      fecha: 'Fecha',
      unidad: 'Unidad',
      tipo: 'Tipo',
      detalle: 'Qué pasó',
      servicio: 'Servicio',
      fotos: 'Fotos',
    },
    sinServicio: 'Sin servicio',
    verFoto: (n: number) => `Ver foto ${n}`,
    cerrarFoto: 'Cerrar',
    errorFoto: 'No se pudo abrir la foto',
    fotoAlt: 'Foto del incidente',
    registradoPor: (cuando: string) => `Registrado ${cuando}`,
    form: {
      titulo: 'Registrar incidente',
      unidad: 'Unidad',
      fecha: 'Fecha del evento',
      fechaAyuda: 'El día en que pasó, aunque lo hayas descubierto después.',
      categoria: 'Tipo de incidente',
      servicio: 'Servicio relacionado (opcional)',
      servicioNinguno: 'Ninguno: no fue durante un servicio',
      servicioAyuda:
        'Si eliges uno, el incidente también queda en el historial de esa orden. Solo salen los servicios de esa unidad ese día.',
      servicioBuscando: 'Buscando servicios…',
      sinServicios: 'Esa unidad no tuvo servicios ese día.',
      descripcion: 'Qué pasó',
      descripcionAyuda:
        'Lo que se encontró o lo que ocurrió, con los datos que ayuden a resolverlo.',
      fotos: 'Fotos (opcional)',
      fotosAyuda: (max: number) => `Hasta ${max} fotos de 5 MB.`,
      agregarFotos: 'Agregar fotos',
      quitarFoto: (nombre: string) => `Quitar ${nombre}`,
      guardar: 'Registrar',
      guardando: 'Registrando…',
      cancelar: 'Cancelar',
      registrado: 'Incidente registrado',
      errores: {
        unidad: 'Elige la unidad',
        fecha: 'Elige la fecha',
        descripcion: 'Cuenta qué pasó (al menos 3 letras)',
        fotos: (max: number) => `Máximo ${max} fotos, de 5 MB cada una`,
        generico: 'No se pudo registrar el incidente',
      },
    },
    historial: (categoria: string) => `Incidente registrado: ${categoria}`,
  },
  /** Reporte para la agencia (punto 5): lo que Uniper le confirma. Nunca lleva chofer ni importes. */
  reporteAgencia: {
    titulo: 'Reporte para agencias',
    /** R-26: el reporte saldría incompleto; se dice antes de imprimir. */
    tope: 'Este día tiene más órdenes de las que caben en el reporte y saldría incompleto. Revisa todas en Órdenes antes de imprimir.',
    ayuda:
      'Una hoja por agencia con sus servicios confirmados del día: folio, servicio, ruta, hora y unidad. No lleva chofer ni importes. Imprímela o guárdala como PDF para enviarla.',
    agencia: 'Agencia',
    todas: 'Todas las agencias',
    imprimir: 'Imprimir o guardar PDF',
    sinPermiso: 'Solo Admin y Operaciones imprimen.',
    hojas: (n: number) => (n === 1 ? '1 hoja' : `${n} hojas`),
    errorCarga: 'No se pudo cargar el reporte',
    vacio: 'No hay servicios confirmados este día',
    vacioAyuda:
      'El reporte lleva solo las órdenes confirmadas. Confirma las que estén en borrador.',
    borradores: (n: number) =>
      n === 1
        ? '1 orden en borrador no sale en el reporte. Confírmala y vuelve a generarlo.'
        : `${n} órdenes en borrador no salen en el reporte. Confírmalas y vuelve a generarlo.`,
    volverTablero: 'Volver al tablero',
    hoja: {
      titulo: (dia: string) => `SERVICIOS CONFIRMADOS · ${dia}`,
      servicios: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
      generado: (cuando: string) => `Generado ${cuando}`,
      col: { hora: 'HORA', folio: 'FOLIO', servicio: 'SERVICIO', ruta: 'RUTA', unidad: 'UNIDAD' },
      sinUnidad: 'Por asignar',
      sinDato: '—',
      pie: 'Estos son los servicios confirmados al momento de generar el reporte. Si algo cambia, Uniper envía uno nuevo.',
    },
  },
  detalle: {
    titulo: 'Detalle de orden',
    migas: 'Órdenes',
    volver: 'Volver a Órdenes',
    errorCarga: 'No se pudo cargar la orden',
    noExiste: 'Esta orden no existe o no tienes acceso.',
    folio: 'Folio',
    pasajeros: (n: number) => `${n} pasajeros`,
    sale: (h: string) => `sale ${h}`,
    regresa: (h: string) => `regresa ${h}`,
    motivoCancelacion: { cancelacion: 'Cancelación', no_show: 'No show' },
    acciones: {
      editar: 'Editar',
      reasignar: 'Cambiar unidad u operador',
      mas: 'Más',
      masDe: 'Más acciones de la orden',
      rescate: 'Rescate',
      rescateNota: 'Se usa el día del servicio, si la unidad falla en el camino.',
      sinRescate: {
        borrador: 'No aplica: falta confirmarla.',
        otro_dia: (f: string) => `No aplica todavía: el servicio es el ${f}.`,
        terminada: 'No aplica: el servicio ya terminó.',
        cancelada: 'No aplica: está cancelada.',
      },
      imprimirOtra: (v: number) => `Imprimir otra vez (v${v})`,
      clonar: 'Clonar a otra fecha',
      cancelar: 'Cancelar orden…',
      descartar: 'Descartar borrador…',
    },
    vida: {
      titulo: 'En qué va la orden',
      paso: {
        creada: 'Creada',
        confirmada: 'Confirmada',
        con_unidad: 'Con unidad',
        impresa: 'Impresa',
        en_servicio: 'En servicio',
        cerrada: 'Cerrada',
        en_recibo: 'En Recibo',
      },
      cancelada: 'Cancelada',
      falta: {
        creada: '',
        confirmada: 'falta confirmar',
        con_unidad: 'falta unidad',
        impresa: 'falta imprimir',
        en_servicio: '',
        cerrada: 'con cupón',
        en_recibo: 'quincena',
      },
      reimprimir: (v: number) => `reimprimir v${v}`,
      conUnidad: (fecha: string, unidad: string) => `${fecha} · ${unidad}`,
      impresa: (v: number, fecha: string) => `v${v} · ${fecha}`,
    },
    siguiente: {
      titulo: 'Siguiente paso:',
      confirmar: 'confírmala para darle folio. Después se asigna unidad y se imprime.',
      confirmarBoton: 'Confirmar orden',
      confirmada: 'Orden confirmada',
      errorConfirmar: 'No se pudo confirmar',
      asignar: 'falta unidad u operador. Asígnalos para poder imprimir la hoja.',
      asignarBoton: 'Asignar unidad',
      imprimir:
        'imprime la orden para entregarla al operador. Se guarda como versión 1 con la hora.',
      imprimirBoton: 'Imprimir orden',
      reimprimir: (v: number) =>
        `cambió después de imprimirse. La hoja v${v - 1} que lleva el operador ya no está al día: reimprímela.`,
      esperar: (fecha: string) =>
        `nada pendiente. Sale el ${fecha}; las horas reales se capturan en el Cierre del día.`,
      cerrar: 'ciérrala en el Cierre del día con la hora de término y el cupón.',
      cerrarBoton: 'Ir al Cierre del día',
      recibo: (cliente: string) =>
        `entra al Recibo de ${cliente} de su quincena. Solo un Admin la corrige, y con motivo.`,
      enRecibo:
        'ya está en un Recibo vigente y no se edita. Para corregirla, cancela su Recibo primero.',
      cancelada: (motivo: string, nota: string | null) =>
        `Cancelada: ${motivo}${nota ? ` (${nota})` : ''}. No genera cargo.`,
    },
    servicio: {
      titulo: 'El servicio',
      realesDespues: 'Las horas reales se capturan en el Cierre del día',
      programadoReal: 'Programado y real',
      tramo: { ida: 'Ida', regreso: 'Regreso', unico: 'Servicio' },
      espera: (libre: string) =>
        `La unidad queda libre ${libre} · se puede usar para otro servicio`,
      saleDe: 'Sale de',
      dejaEn: 'Deja en',
      recogeEn: 'Recoge en',
      terminaEn: 'Termina en',
      parada: (n: number) => `Parada ${n}`,
      aprox: (h: string) => `aprox. ${h}`,
      real: (h: string) => `real ${h}`,
      porDefinir: 'Por definir',
      horas: (h: number, m: number) => (m ? (h ? `${h} h ${m} min` : `${m} min`) : `${h} h`),
    },
    lugares: {
      titulo: 'Unidad y lugares',
      sinUnidad: 'Sin unidad',
      sinOperador: 'Sin operador',
      capacidad: (n: number) => `${n} lugares`,
      titular: 'operador titular',
      titularEs: (nombre: string) => `titular: ${nombre}`,
      ocupacion: (pax: number, lugares: number) => `${pax} pasajeros en ${lugares} lugares`,
      sinPax: (lugares: number) => `Pax sin capturar · ${lugares} lugares`,
      alcanza: 'Alcanza',
      contratada: (n: number, sobran: number) =>
        `Contratada: ${n} lugares${sobran > 0 ? ` · sobran ${sobran}` : ''}`,
      masDeLoContratado: (pax: number, n: number) => `Lleva ${pax} con ${n} lugares contratados.`,
      masAyuda: 'Es aviso, no bloquea. Si cambió lo pactado, corrígelo en Editar.',
      rescate: (hora: string, unidad: string, operador: string) =>
        `Rescate desde las ${hora}: ${unidad} con ${operador}.`,
      antes: (u: string) => `Antes: ${u}`,
    },
    cobro: {
      titulo: 'Cobro',
      soloDinero: 'Solo Admin y Cobranza',
      calculo: (tarifa: string, cap: number) => `${tarifa} × ${cap} lugares`,
      subtotal: 'Subtotal',
      iva: (t: number) => `IVA ${Math.round(t * 100)}%`,
      total: 'Total MXN',
      sinTarifa: 'Este servicio no tenía tarifa en esa fecha.',
      entra: (cliente: string) => `Entra al Recibo de ${cliente} cuando se cierre con cupón.`,
      nota: 'El rescate no cambia el cobro: se honra el precio pactado con la unidad original.',
    },
    historial: {
      titulo: 'Qué ha pasado',
      vacio: 'Aún no hay cambios.',
      quien: (u: string | null, cuando: string) => `${u ?? 'Sistema'} · ${cuando}`,
      motivo: (m: string) => `«${m}»`,
    },
    versiones: {
      titulo: 'Versiones impresas',
      pendiente: (v: number) => `v${v}`,
      pendienteTexto: 'Pendiente de imprimir',
      vacio:
        'Todavía no se imprime. Si cambias algo después de imprimir, aquí te avisamos que hay que reimprimir.',
    },
    editar: {
      titulo: 'Editar orden',
      pax: 'Pasajeros (opcional)',
      paxSinDato: 'Sin dato',
      referencia: 'Referencia del cliente',
      barco: 'Barco',
      sinBarco: 'Sin barco',
      notas: 'Notas para el operador',
      salida: 'Hora de salida',
      regreso: 'Hora de regreso',
      capacidad: 'Lugares contratados',
      destino: 'Destino',
      porDefinir: 'Por definir',
      guardar: 'Guardar cambios',
      sinCambios: 'No hay cambios por guardar',
      guardado: 'Cambios guardados',
      errorGuardar: 'No se pudo guardar',
      enCurso: 'En curso solo cambian pax, barco, referencia y notas.',
      errores: {
        pax: 'De 1 a 80',
        capacidad: 'De 1 a 80',
        referencia: 'Escribe la referencia',
      },
    },
    rescate: {
      titulo: 'Rescate',
      ayuda:
        'Emergencia: otra unidad toma el servicio desde un punto. Solo se registra lo sucedido y la unidad de reemplazo; el cobro no cambia (se honra el precio pactado con la unidad original).',
      desde: 'Desde',
      desdeTramo: (tipo: string, hora: string) => `Inicio del ${tipo} (${hora})`,
      desdeHora: 'Desde una hora',
      hora: 'Hora del rescate',
      unidad: 'Unidad de rescate',
      operador: 'Operador',
      elegir: 'Elige…',
      motivo: 'Motivo',
      motivoAyuda: 'Qué pasó (por ejemplo, falla de aire).',
      guardar: 'Registrar rescate',
      guardado: 'Rescate registrado',
      error: 'No se pudo registrar el rescate',
      errores: {
        unidad: 'Elige la unidad',
        operador: 'Elige el operador',
        motivo: 'Escribe el motivo',
        hora: 'Hora inválida',
      },
    },
    cancelar: {
      titulo: 'Cancelar orden',
      impacto: 'Se cancela esta orden. No genera cargo y su folio se conserva.',
      confirmar: 'Cancelar orden',
      cancelada: 'Orden cancelada',
      error: 'No se pudo cancelar',
    },
    descartar: {
      titulo: 'Descartar borrador',
      impacto: 'Este borrador se borra. No gasta folio y no se puede recuperar.',
      confirmar: 'Descartar',
      descartada: 'Borrador descartado',
      error: 'No se pudo descartar',
    },
  },
  clonar: {
    tituloOrdenes: (n: number) => (n === 1 ? 'Clonar 1 orden' : `Clonar ${n} órdenes`),
    tituloDia: (dia: string) => `Clonar el día ${dia}`,
    tituloTraer: (destino: string) => `Traer un día a ${destino}`,
    boton: 'Clonar',
    botonDia: 'Clonar día',
    botonCantidad: (n: number) => `Clonar (${n})`,
    botonFila: (folio: string) => `Clonar ${folio}`,
    traerAqui: 'Clonar otro día aquí',
    modos: 'Cómo clonar',
    modo: {
      fecha: { titulo: 'A una fecha', desc: 'Copia a un solo día' },
      rango: { titulo: 'Rango con intervalo', desc: 'Cada N días entre dos fechas' },
      semana: { titulo: 'Días de la semana', desc: 'Ej. lunes y jueves en un rango' },
    },
    fecha: 'Fecha de destino',
    periodo: 'Periodo',
    cada: 'Cada cuántos días',
    dias: 'Días de la semana',
    origen: 'Día que se copia',
    diasSemana: ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'],
    inicialesSemana: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
    vistaPrevia: 'Vista previa',
    cuenta: (n: number) => (n === 1 ? '1 orden' : `${n} órdenes`),
    detalle: (dias: number, ordenes: number) =>
      `${dias} ${dias === 1 ? 'día' : 'días'} × ${ordenes} ${ordenes === 1 ? 'orden' : 'órdenes'}. Conservan agencia, servicio, horario y pax; la unidad se asigna en el tablero.`,
    sinFechas: 'Elige al menos una fecha para ver cuántas órdenes se crearían.',
    sinOrdenes: 'Ese día no tiene órdenes que clonar.',
    pasadas: (n: number) =>
      n === 1
        ? 'Se dejó fuera 1 fecha que ya pasó.'
        : `Se dejaron fuera ${n} fechas que ya pasaron.`,
    topeOrdenes: (n: number, tope: number) =>
      `Serían ${n} órdenes y el tope por clonación es ${tope}. Reduce las fechas o las órdenes.`,
    topeDias: (n: number, tope: number) =>
      `Son ${n} días y el tope por clonación es ${tope}. Acorta el rango.`,
    nota: 'Todas nacen como Borrador y aparecen en Por confirmar.',
    crear: (n: number) => (n === 1 ? 'Crear 1 borrador' : `Crear ${n} borradores`),
    creados: (n: number) =>
      n === 1 ? '1 borrador creado en Por confirmar' : `${n} borradores creados en Por confirmar`,
    error: 'No se pudo clonar',
  },
  porConfirmar: {
    titulo: 'Por confirmar',
    migas: 'Operación',
    ayuda: 'Borradores clonados o sugeridos. Cuando la agencia confirme, ajusta pax y confírmalos.',
    pendientes: (n: number) =>
      n === 1 ? '1 pendiente' : `${n.toLocaleString('es-MX')} pendientes`,
    /** R-26: la bandeja trae los más cercanos; el total sale de la base. */
    tope: 'Ves primero los más cercanos. «Confirmar todo» confirma los que ves; al terminar entran los siguientes.',
    vacio: 'No hay borradores por confirmar',
    vacioAyuda: 'Lo que se clona o se guarda como borrador aparece aquí.',
    irAOrdenes: 'Ir a Órdenes',
    errorCarga: 'No se pudo cargar la bandeja',
    dia: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
    grupo: (servicios: number, pax: number | null) =>
      `${servicios} ${servicios === 1 ? 'servicio' : 'servicios'}${pax === null ? '' : ` · ${pax} pax`}`,
    agregarPax: 'Agregar pax',
    confirmar: 'Confirmar',
    confirmarGrupo: 'Confirmar todo',
    confirmarTodo: (n: number) => `Confirmar todo · ${n}`,
    confirmarTodoTitulo: 'Confirmar todos los borradores',
    confirmarTodoImpacto: (n: number) =>
      `Se confirman ${n} órdenes. Reciben su folio en orden de fecha y hora.`,
    descartar: 'Descartar',
    descartarTitulo: 'Descartar borradores',
    descartarImpacto: (n: number, agencia: string, dia: string) =>
      `Se descartan ${n} ${n === 1 ? 'borrador' : 'borradores'} de ${agencia} del ${dia}. No gastan folio y no se pueden recuperar.`,
    paxDe: (referencia: string) => `Pax de ${referencia}`,
    cambio: (d: number) => (d > 0 ? `+${d}` : `−${-d}`),
    cap: (n: number) => `cap. ${n}`,
    noCabe: (pax: number, cap: number) => `${pax} pax no caben en ${cap} lugares`,
    subirA: (n: number) => `Subir a ${n} lugares`,
    sinMayor: 'Ninguna unidad de la flota es tan grande; divide el grupo en dos órdenes.',
    regreso: (hora: string) => `regresa ${hora}`,
    confirmadas: (n: number) => (n === 1 ? '1 orden confirmada' : `${n} órdenes confirmadas`),
    descartadas: (n: number) => (n === 1 ? '1 borrador descartado' : `${n} borradores descartados`),
    errorConfirmar: 'No se pudo confirmar',
    errorDescartar: 'No se pudo descartar',
    porDefinir: 'Por definir',
  },
  cierre: {
    titulo: 'Cierre del día',
    migas: 'Operación',
    ayuda: 'Copia lo que dicen las hojas firmadas. Abrimos el día más antiguo que falta.',
    /** R-26: un día trae como máximo 500 órdenes; el total sale de la base. */
    tope: 'Este día tiene más servicios de los que caben en la pantalla. Se muestran los primeros por hora; avisa para ampliar el tope.',
    dia: 'Elegir otro día',
    dias: 'Días',
    avance: (c: number, t: number) => `${c} de ${t} cerradas`,
    sinCupon: (n: number) => (n === 1 ? '1 sin cupón' : `${n} sin cupón`),
    canceladas: (n: number) =>
      n === 1 ? '1 cancelada · no se cierra' : `${n} canceladas · no se cierran`,
    autoguardado: 'Se guarda solo al pasar a la siguiente fila',
    chip: {
      porCerrar: (n: number) => `${n} por cerrar`,
      cerrado: 'Cerrado',
      manana: 'mañana',
      sinServicios: 'sin servicios',
    },
    masAntiguos: (fecha: string, n: number) =>
      `Hay días más antiguos por cerrar: ${fecha} con ${n === 1 ? '1 servicio' : `${n} servicios`}.`,
    irA: (fecha: string) => `Ir al ${fecha}`,
    completo: (dia: string, n: number) =>
      `${dia} cerrado. ${n === 1 ? 'El servicio ya se puede cobrar' : `Los ${n} servicios ya se pueden cobrar`}.`,
    siguienteDia: (dia: string, n: number) =>
      ` Sigue el ${dia}, con ${n === 1 ? '1 pendiente' : `${n} pendientes`}.`,
    cerrarDia: (dia: string) => `Cerrar el ${dia}`,
    todoCerrado: 'Todo cerrado. No quedan días con servicios por cerrar.',
    faltan: (n: number) =>
      `Faltan ${n === 1 ? '1 servicio' : `${n} servicios`}. Llena las filas marcadas y el día se cierra solo.`,
    futuro: 'Ese día todavía no llega',
    futuroAyuda: 'Solo se cierran servicios de hoy o de días anteriores.',
    vacio: 'No hay servicios confirmados ese día',
    vacioAyuda: 'Los borradores no se cierran: primero se confirman.',
    errorCarga: 'No se pudo cargar el día',
    col: {
      estado: 'Estado',
      orden: 'Orden',
      programado: 'Programado',
      pax: 'Pax',
      salida: 'Salió',
      opcional: '(opcional)',
      termino: 'Terminó',
      cupon: 'Cupón del cliente',
      olvidaron: '¿Olvidaron algo?',
      foto: 'Foto',
      acciones: 'Más',
      paradas: 'Paradas · llegó / salió',
      destino: 'Destino',
      notas: 'Notas',
    },
    obligatorio: 'obligatorio para cerrar',
    programado: (de: string, a: string | null) => (a ? `${de} a ${a}` : de),
    parada: (n: number, lugar: string) => `${n}. ${lugar}`,
    llegada: (n: number) => `Llegada real a la parada ${n}`,
    salidaParada: (n: number) => `Salida real de la parada ${n}`,
    paxDe: (folio: string) => `Pasajeros reales de ${folio}`,
    salidaDe: (folio: string) => `Salió ${folio}`,
    terminoDe: (folio: string) => `Terminó ${folio}`,
    cuponDe: (folio: string) => `Cupón ${folio}`,
    noAplica: 'No aplica',
    escribeCupon: 'Escribe el cupón',
    si: 'Sí',
    no: 'No',
    queOlvidaron: 'Qué olvidaron',
    queOlvidaronDe: (folio: string) => `Qué olvidaron en ${folio}`,
    destinoDe: (folio: string) => `Destino de ${folio}`,
    porDefinir: 'Por definir',
    destinoPorDefinir: 'Destino por definir',
    notasDe: (folio: string) => `Notas de ${folio}`,
    sinUnidad: 'Sin unidad: asígnala en el tablero',
    corregibleHasta: (h: string) => `Puedes corregirla hasta las ${h}`,
    fija: 'Cerrada. La corrige Admin, con motivo.',
    enRecibo: 'En Recibo: ya no se corrige.',
    circulo: {
      pendiente: 'Pendiente',
      falta: 'Falta un dato',
      guardando: 'Guardando…',
      cerrada: 'Cerrada',
      sinGuardar: 'Sin guardar: se reintenta solo',
      error: 'No se guardó',
      cancelada: 'No se hizo',
    },
    falta: {
      pax: 'El pax va de 1 a 80',
      termino: 'Falta el término',
      cupon: 'Falta el cupón',
      objetos: 'Falta qué olvidaron',
    },
    conflicto: 'Otro usuario la cerró o la cambió mientras capturabas.',
    usarLoNuevo: 'Ver lo nuevo',
    cuponRepetido: (folios: string[]) => `Cupón repetido en ${folios.join(', ')}. Revisa el papel.`,
    sinConexion: 'Sin conexión: la fila quedó sin guardar y se reintenta sola.',
    errorGuardar: 'No se pudo cerrar la fila',
    masDe: (folio: string) => `Más de ${folio}`,
    detalle: 'Paradas, destino y notas',
    noSeHizo: 'No show o cancelación…',
    noSeHizoTitulo: 'El servicio no se hizo',
    noSeHizoConfirmar: 'Marcar como no realizado',
    noSeHizoImpacto: (folio: string) =>
      `La orden ${folio} queda cancelada sin cargo. Elige si fue cancelación o no show.`,
    errorCancelar: 'No se pudo marcar',
    marcada: 'Orden marcada como no realizada',
    corregir: 'Corregir (Admin, con motivo)',
    motivoCorreccion: 'Motivo de la corrección',
    faltaMotivo: 'Escribe el motivo de la corrección',
    subir: 'Subir',
    ver: 'Ver',
    subirFoto: (folio: string) => `Subir la foto del cupón de ${folio}`,
    verFoto: (folio: string) => `Ver la foto del cupón de ${folio}`,
    fotoSubida: 'Foto del cupón guardada',
    errorFoto: 'No se pudo subir la foto',
    atajos: {
      tab: 'siguiente campo',
      enter: 'siguiente fila',
      hora: 'se lee 8:45',
      igual: 'copia la hora programada',
    },
  },
  tablero: {
    titulo: 'Tablero del día',
    /** R-26: un día trae como máximo 500 órdenes y 1,000 tramos; el total sale de la base. */
    tope: 'Este día tiene más servicios de los que caben en el tablero y falta una parte. Revisa todos en Órdenes.',
    dia: 'Día',
    anterior: 'Día anterior',
    siguiente: 'Día siguiente',
    hoy: 'Hoy',
    manana: 'Mañana',
    nuevaOrden: 'Nueva orden',
    imprimir: {
      boton: 'Imprimir órdenes y rol',
      ordenes: (n: number) => (n === 0 ? 'Órdenes: todas impresas' : `Órdenes sin imprimir · ${n}`),
      rol: 'Rol del día',
      reimprimirRol: (v: number) => `Reimprimir rol · v${v}`,
      soloVer: 'Rol del día (solo ver)',
      reporteAgencias: 'Reporte para agencias',
    },
    /** Primario cuando el día ya está listo (todo con unidad y operador, sin bloqueos). */
    imprimirRolListo: 'Imprimir rol',
    franja: {
      etiqueta: 'Cómo va el día',
      servicios: 'Servicios',
      pasajeros: (n: number) => (n === 1 ? '1 pasajero' : `${n} pasajeros`),
      producto: {
        sencillo: ['traslado sencillo', 'traslados sencillos'],
        redondo: ['traslado redondo', 'traslados redondos'],
        recorrido: ['tour', 'tours'],
        jornada: ['jornada', 'jornadas'],
      } as Record<string, [string, string]>,
      conUnidad: 'Con unidad y operador',
      de: (m: number) => `de ${m}`,
      falta: (n: number) =>
        n === 1 ? 'Falta 1 · ver a la derecha' : `Faltan ${n} · ver a la derecha`,
      todoAsignado: 'Todo asignado',
      borradores: (n: number) =>
        n === 1 ? '1 borrador por confirmar' : `${n} borradores por confirmar`,
      impresas: 'Órdenes impresas',
      alFinal: 'Se imprimen al final',
      todasImpresas: 'Todas impresas',
      porReimprimir: (n: number) => (n === 1 ? '1 por reimprimir' : `${n} por reimprimir`),
      rolSin: 'rol sin imprimir',
      rolAlDia: (v: number) => `rol v${v} al día`,
      rolViejo: (v: number) => `rol v${v} por reimprimir`,
      unidades: 'Unidades ocupadas',
      flota: (codigo: string, n: number, total: number) => `${codigo} ${n} de ${total}`,
      listo: 'Día listo: todo tiene unidad y operador y no hay bloqueos.',
      errorCarga: 'No se pudo cargar el avance del día',
    },
    soloLectura: 'Día pasado: solo lectura',
    vistas: 'Vista del tablero',
    vista: { linea: 'Línea de tiempo', rol: 'Rol' },
    /** El motivo lo da la base: «Ocupado: UO-98, 08:00 a 12:30» (R-20). */
    operadorOcupado: (nombre: string, motivo: string) => `${nombre} · ${motivo}`,
    rol: {
      ayuda:
        'El mismo rol de siempre, ahora sale de las órdenes. Cambia unidad u operador directo en la fila.',
      imprimirOrdenes: (n: number) => `Imprimir órdenes · ${n}`,
      imprimirRol: 'Imprimir rol',
      reimprimirRol: (v: number) => `Reimprimir rol · v${v}`,
      todasFlotas: 'Todas',
      filtroFlota: 'Flota',
      sinAsignar: 'Sin asignar',
      resumenGrupo: (servicios: number, unidades: number) =>
        `${servicios} ${servicios === 1 ? 'servicio' : 'servicios'} · ${unidades} ${unidades === 1 ? 'unidad' : 'unidades'}`,
      resumenSin: (n: number) =>
        n === 1 ? '1 orden espera unidad' : `${n} órdenes esperan unidad`,
      vacio: 'Ningún servicio de esta flota este día',
      col: {
        unidad: 'Unidad',
        operador: 'Operador',
        lugar: 'Lugar',
        hora: 'Hora',
        regreso: 'Regreso',
        barco: 'Barco',
        folio: 'Folio',
        agencia: 'Agencia · servicio',
        pax: 'Pax',
        estado: 'Estado',
        impresa: 'Impresa',
        acciones: 'Acciones',
      },
      unidadDe: (folio: string) => `Unidad de ${folio}`,
      operadorDe: (folio: string) => `Operador de ${folio}`,
      sinUnidad: 'Sin unidad',
      sinOperador: 'Sin operador',
      confirmar: 'Confirmar orden',
      confirmada: (folio: string) => `Orden ${folio} confirmada`,
      errorConfirmar: 'No se pudo confirmar',
      imprimir: 'Imprimir orden',
      clonar: 'Clonar orden',
      sinImprimir: 'Sin imprimir',
      reimprimir: 'Reimprimir',
      impresa: (v: number) => `v${v}`,
      guardado: 'Cambio guardado',
    },
    soloLecturaRol: 'Solo lectura',
    reconectando: 'Reconectando… lo que ves puede estar atrasado.',
    vacio: 'No hay servicios este día',
    vacioAyuda: 'Captura o clona las órdenes de este día.',
    irAOrdenes: 'Ir a Órdenes',
    errorCarga: 'No se pudo cargar el tablero',
    linea: {
      etiqueta: (flota: string) => `Línea de tiempo de ${flota}`,
      enUso: (n: number, total: number) => `${n} de ${total} en uso`,
      verLibres: (n: number) => (n === 1 ? 'Ver 1 libre' : `Ver ${n} libres`),
      ocultarLibres: 'Ocultar libres',
      libre: 'Libre',
      sinOperador: 'Sin operador',
      enTaller: 'En taller con servicio',
      capacidad: (n: number) => `${n} lugares`,
      ahora: 'Ahora',
      fueraDeVentana: (n: number) =>
        n === 1
          ? '1 servicio queda fuera del horario del tablero'
          : `${n} servicios quedan fuera del horario del tablero`,
      unidadYOperador: 'Unidad y operador',
      recorteIzq: 'empieza antes de lo que se ve',
      recorteDer: 'termina después de lo que se ve',
      pie: 'Haz clic en un servicio para verlo o cambiarlo de unidad. También puedes arrastrarlo.',
      pieLectura: 'Haz clic en un servicio para verlo.',
      avisos: (n: number) => (n === 1 ? '1 aviso en la línea' : `${n} avisos en la línea`),
      bloqueos: (n: number) => (n === 1 ? '1 bloqueo en la línea' : `${n} bloqueos en la línea`),
      verEnLinea: 'Ver',
      corto: (agencia: string, pax: number | null) =>
        pax === null ? agencia : `${agencia} · ${pax}`,
      leyenda: {
        traslado: 'Traslado',
        recorrido: 'Tour',
        jornada: 'Jornada',
        espera: 'Espera (libre para intercalar)',
        borrador: 'Borrador',
        conflicto: 'Traslape',
      },
      ver: (servicio: string) => `Ver ${servicio}`,
      bloque: (agencia: string, referencia: string, pax: number | null, folio: string | null) =>
        `${agencia} · ${referencia}${pax === null ? '' : ` · ${pax} pax`}${folio ? ` · ${folio}` : ''}`,
    },
    alertas: {
      conAlerta: 'con alerta',
      bloqueo: 'Bloqueo',
      aviso: 'Aviso',
      traslape: {
        titulo: (unidad: string) => `Traslape en ${unidad}`,
        desc: (a: string, b: string) => `${a} se pisa con ${b}.`,
      },
      capacidad: {
        titulo: (unidad: string) => `${unidad} ya no alcanza`,
        desc: (orden: string, cap: number, pax: number) =>
          `${orden}: la unidad es de ${cap} lugares y la orden lleva ${pax} pax.`,
      },
      sin_unidad: {
        titulo: 'Orden sin unidad',
        desc: (orden: string, hora: string) => `${hora} · ${orden}`,
      },
      sin_operador: {
        titulo: (unidad: string) => `${unidad} sin operador`,
        desc: (orden: string, hora: string) => `${hora} · ${orden}`,
      },
      regreso_justo: {
        titulo: (unidad: string) => `Regreso justo en ${unidad}`,
        desc: (orden: string, min: number, otra: string) =>
          `${orden} termina ${min} min antes del regreso de ${otra}.`,
      },
      modificada_tras_imprimir: {
        titulo: (folio: string) => `${folio} cambió después de imprimirse`,
        desc: (version: number) => `Impresa v${version}. Hay que reimprimirla.`,
      },
      unidad_en_taller: {
        titulo: (unidad: string) => `${unidad} en taller con servicio`,
        desc: (orden: string) => `${orden} necesita otra unidad.`,
      },
    },
    tarjeta: {
      etiqueta: (folio: string) => `Servicio ${folio}`,
      ruta: (origen: string, destino: string) => `${origen} → ${destino}`,
      horario: (sale: string, regresa: string | null) =>
        regresa ? `Sale ${sale} · regresa ${regresa}` : `Sale ${sale}`,
      paxEnLugares: (pax: number | null, lugares: number) =>
        pax === null ? `${lugares} lugares` : `${pax} pax en ${lugares} lugares`,
      paxSinUnidad: (pax: number | null, contratados: number) =>
        pax === null
          ? `${contratados} lugares contratados · sin unidad`
          : `${pax} pax · sin unidad`,
      unidad: (numero: string, operador: string) => `${numero} · ${operador}`,
      hueco: (desde: string, hasta: string) =>
        `Entre ${desde} y ${hasta} la unidad queda libre para otro servicio.`,
      cambiarUnidad: 'Cambiar unidad',
      verOrden: 'Ver orden',
      reimprimir: 'Reimprimir',
      cerrar: 'Cerrar',
      sinDestino: 'destino por definir',
    },
    mover: {
      justo: (min: number) => `Cuidado: solo quedan ${min} min antes del regreso de esa unidad`,
      movida: (unidad: string) => `Movida a ${unidad}`,
      error: 'No se pudo mover',
    },
    sin: {
      titulo: 'Sin unidad',
      cuenta: (n: number) =>
        n === 1 ? '1 servicio sin unidad u operador' : `${n} servicios sin unidad u operador`,
      ayuda: 'Es lo que falta para dejar listo el día.',
      vacio: 'Todo el día tiene unidad y operador.',
      linea: (referencia: string, producto: string, ruta: string, folio: string) =>
        `${referencia} · ${producto} · ${ruta} · ${folio}`,
      /** La causa real, como la dice la base (D5). Lo contratado va aparte. */
      causa: {
        hay_libre: (n: number) =>
          n === 1 ? 'Hay 1 unidad libre que alcanza.' : `Hay ${n} unidades libres que alcanzan.`,
        ocupadas_las_que_alcanzan: (pax: number, capacidades: number[]) =>
          `Lleva ${pax}; las unidades de ${lista(capacidades)} están ocupadas a esa hora.`,
        ninguna_alcanza: (pax: number, max: number | null) =>
          max === null
            ? `Lleva ${pax}; no hay unidades activas.`
            : `Lleva ${pax}; ninguna unidad tiene tantos lugares (la más grande es de ${max}).`,
        sinOperador: (unidad: string) => `Tiene ${unidad}; falta el operador.`,
      },
      masContratado: (pax: number, contratados: number) =>
        `${pax} de ${contratados} contratados · no bloquea, se corrige en Editar`,
      pregunta: '¿Qué quieres hacer?',
      opcion: {
        liberar: {
          titulo: (capacidades: number[]) => `Liberar una unidad de ${lista(capacidades)} lugares`,
          ayuda: 'Mueve primero el servicio que la ocupa. Te mostramos con cuál choca.',
          cta: 'Ver unidades que alcanzan',
        },
        pax: {
          titulo: 'Corregir pasajeros',
          ayuda: 'Si el cliente confirmó menos, cambia la cifra y la unidad aparece sola.',
          cta: 'Cambiar pasajeros',
        },
        mano: {
          titulo: 'Elegir unidad y operador a mano',
          ayuda:
            'Ves todas las unidades: las libres, las ocupadas y las que no caben, con su motivo.',
          cta: 'Elegir a mano',
        },
      },
      sugerida: 'Sugerida',
      sinSugerencia: 'La rotación no encontró unidad y operador libres. Ve las opciones.',
      asignar: 'Asignar',
      opciones: 'Ver opciones',
      asignada: (unidad: string) => `Asignada a ${unidad}`,
      errorAsignar: 'No se pudo asignar',
      falta: 'Falta unidad u operador',
    },
  },
  captura: {
    titulo: 'Nueva orden',
    subtitulo: 'Cinco respuestas y listo. Todo lo demás se hereda del servicio.',
    pasos: {
      fecha: '¿Para cuándo?',
      agencia: '¿Qué agencia?',
      servicio: '¿Qué servicio?',
      horario: '¿A qué hora?',
      unidades: '¿Cuántas unidades?',
    },
    pistas: {
      agencia: 'Busca o elige una frecuente.',
      servicio: 'Por ruta. Busca por referencia si son muchos.',
      horario: 'Hora de Cozumel.',
      unidades: 'Mismo horario y misma ruta.',
    },
    pasoListo: (paso: string) => `${paso} Contestado`,
    cambiar: 'Cambiar',
    fecha: 'Fecha del servicio',
    otraFecha: 'Otra fecha',
    agencia: 'Agencia',
    buscarAgencia: 'Buscar agencia',
    frecuentes: 'Las que más capturas',
    servicios: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
    servicio: 'Servicio',
    buscarServicio: 'Buscar por referencia (XTrail…)',
    sinCoincidencias: 'Ningún servicio coincide con esa búsqueda.',
    nuevoServicioPara: (agencia: string) => `+ Crear un servicio nuevo para ${agencia}`,
    sinServicios: 'Esta agencia aún no tiene servicios',
    crearServicio: 'Crear su primer servicio',
    salida: 'Hora de salida',
    regreso: 'Recoge para regresar',
    precargada: 'Precargada',
    regresoAyuda: 'Precargada con la espera del servicio. Ajústala si la agencia pidió otra.',
    unidades: 'Unidades',
    unidadesDe: (n: number) => (n === 1 ? '1 unidad' : `${n} unidades`),
    unidadesUna:
      'Se crea una orden. Si la agencia pidió varias unidades a la misma hora, elige cuántas y se crean de una vez.',
    unidadesVarias: (n: number, lugares: number) =>
      `${n} órdenes iguales, cada una con su propia unidad: ${n} × ${lugares} = ${n * lugares} lugares. La unidad y el operador de cada una se eligen en el Tablero.`,
    unidadesMaximo: '10 órdenes es el máximo por captura. Si son más, guarda y captura otra tanda.',
    algoMas: '¿Algo más?',
    algoMasAyuda: 'Opcional. Si no lo sabes, déjalo.',
    extras: {
      barco: 'Barco',
      pax: 'Pasajeros',
      notas: 'Notas para el operador',
      ajustar: 'Ajustar lugares o destino',
    },
    agregar: (que: string) => `+ ${que}`,
    quitar: (que: string) => `Quitar ${que.toLowerCase()}`,
    barco: 'Barco',
    sinBarco: 'Sin barco',
    pax: 'Pasajeros (opcional)',
    paxSinDato: 'Sin dato',
    paxVarias:
      'Con varias unidades, los pasajeros se anotan después en Por confirmar o en el Cierre del día.',
    notas: 'Notas para el operador',
    notasAyuda: 'Salen en la orden impresa.',
    sinDestino:
      'El servicio no trae destino. Si ya lo sabes, anótalo en «Ajustar lugares o destino».',
    lugares: (n: number) => `${n} lugares`,
    flotaCualquiera: 'Cualquier flota',
    vehiculoCualquiera: 'Cualquier vehículo',
    herenciaAyuda:
      'En la orden solo se cambian los lugares contratados y el destino. Lo demás se cambia en el servicio.',
    producto: 'Producto',
    ruta: 'Ruta del servicio',
    flota: 'Flota',
    tipoVehiculo: 'Tipo de vehículo',
    capacidad: 'Lugares contratados',
    referencia: 'Referencia del cliente',
    destino: 'Destino (opcional)',
    duplicado: (folio: string) =>
      `Ya existe ${folio} con la misma agencia, servicio, fecha y hora.`,
    duplicadoAyuda: 'Revisa que no sea la misma orden antes de guardar.',
    resumen: {
      faltaAgencia: 'Falta la agencia',
      faltaAgenciaAyuda: 'Elige la agencia y después su servicio.',
      faltaServicio: 'Falta el servicio',
      faltaServicioAyuda: 'El servicio trae la ruta, los lugares y el regreso.',
      faltaHora: 'Falta la hora de salida',
      faltaHoraAyuda: 'Con la hora queda lista la orden.',
      confirmadas: (n: number) =>
        n === 1 ? 'Se crea 1 orden confirmada' : `Se crean ${n} órdenes confirmadas`,
      borradores: (n: number) => (n === 1 ? 'Se crea 1 borrador' : `Se crean ${n} borradores`),
      conFolio: (n: number) =>
        n === 1
          ? 'Con su folio, sin unidad todavía.'
          : 'Cada una con su folio, sin unidad todavía.',
      sinFolio: (n: number) =>
        n === 1 ? 'Va a Por confirmar, sin folio.' : 'Van a Por confirmar, sin folio.',
      horario: (salida: string, regreso: string) => `${salida} a ${regreso}`,
    },
    cobro: 'Cobro estimado',
    cobroAyuda: 'Lo calcula el sistema con la tarifa vigente en esa fecha.',
    sinTarifa: 'Sin tarifa para esa fecha',
    porOrden: (n: number, total: string) => `${n} × ${total}`,
    verDesglose: 'Ver desglose',
    ocultarDesglose: 'Ocultar desglose',
    tarifa: 'Tarifa',
    subtotal: 'Subtotal por orden',
    iva: 'IVA por orden',
    total: 'Total por orden',
    noConfirma: 'La agencia aún no confirma',
    cta: {
      crear: (n: number) => (n === 1 ? 'Crear orden' : `Crear ${n} órdenes`),
      borradores: (n: number) => (n === 1 ? 'Guardar borrador' : `Guardar ${n} borradores`),
      agencia: 'Elige la agencia',
      servicio: 'Elige el servicio',
      hora: 'Indica la hora de salida',
    },
    atajo: (mac: boolean) => (mac ? '⌘ Enter' : 'Ctrl Enter'),
    guardarOtra: 'Guardar y capturar otra',
    listo: {
      confirmadas: (n: number) => (n === 1 ? 'Orden confirmada' : `${n} órdenes confirmadas`),
      borradores: (n: number) =>
        n === 1 ? 'Borrador en Por confirmar' : `${n} borradores en Por confirmar`,
      ayudaConfirmadas: 'Cada una con su folio. La unidad y el operador se eligen en el Tablero.',
      ayudaBorradores: 'Sin folio hasta que la agencia confirme.',
      creadas: 'Órdenes creadas',
      borrador: (i: number) => `Borrador ${i}`,
      sinUnidad: 'Sin unidad',
      porConfirmar: 'Por confirmar',
      irTablero: 'Asignar unidades en el Tablero',
      irPorConfirmar: 'Ir a Por confirmar',
      otraPara: (agencia: string) => `Capturar otra para ${agencia}`,
      cerrar: 'Cerrar',
    },
    creadas: (n: number, folios: string) =>
      n === 1 ? `Orden ${folios} confirmada` : `${n} órdenes confirmadas: ${folios}`,
    borradoresCreados: (n: number) =>
      n === 1 ? 'Borrador guardado en Por confirmar' : `${n} borradores guardados en Por confirmar`,
    recuperado: 'Recuperamos lo que estabas capturando.',
    descartar: 'Empezar de nuevo',
    errores: {
      agencia: 'Elige la agencia',
      servicio: 'Elige el servicio',
      servicioNoExiste: 'El servicio que tenías elegido ya no existe o está inactivo. Elige otro.',
      hora: 'Indica la hora de salida',
      regreso: 'Indica la hora de regreso',
      regresoAntes: 'El regreso debe ser después de la salida',
      pax: 'De 1 a 80',
      cantidad: 'De 1 a 10 unidades por captura',
      red: 'No se pudo guardar. Revisa tu conexión: lo capturado sigue aquí.',
      revisar: 'Falta algo por completar: revisa los campos marcados en rojo.',
    },
  },
  recibos: {
    migas: 'Liquidación',
    nuevo: 'Nuevo Recibo',
    nuevoAyuda:
      'Elige agencia y periodo. Entran las órdenes cerradas que aún no están en un Recibo; si la agencia exige cupón, solo las que lo traen.',
    agencia: 'Agencia',
    elegirAgencia: 'Elige la agencia',
    periodo: 'Periodo',
    quincenaAnterior: 'Quincena anterior',
    diasCredito: (n: number) => `${n} días`,
    sinAgencia: 'Elige una agencia para ver qué se puede cobrar.',
    elegibles: 'Órdenes elegibles',
    seleccionadas: (n: number, total: number) => `${n} de ${total} seleccionadas`,
    sinElegibles: 'No hay órdenes por cobrar en este periodo',
    sinElegiblesAyuda: 'Revisa las alertas o elige otro periodo.',
    enOtros: (recibo: string, n: number) =>
      n === 1
        ? `1 orden del periodo ya está en ${recibo} y no se muestra.`
        : `${n} órdenes del periodo ya están en ${recibo} y no se muestran.`,
    alerta: {
      sin_cerrar: (f: string) => `${f} no está cerrada.`,
      sin_cupon: (f: string) => `${f} está cerrada sin cupón.`,
      sin_tarifa: (f: string) => `${f} no tiene tarifa.`,
    },
    alertaAyuda: {
      sin_cerrar: 'Ciérrala en Cierre del día para incluirla.',
      sin_cupon: 'Captura el cupón para incluirla.',
      sin_tarifa: 'Su servicio no tenía tarifa al crear la orden. Revísala con Admin.',
    },
    alertasTitulo: (n: number) => (n === 1 ? '1 orden no entra' : `${n} órdenes no entran`),
    futuras: (n: number, rango: string) =>
      n === 1
        ? `1 orden es de un día que todavía no llega (${rango}). Entrará en un Recibo cuando se cierre.`
        : `${n} órdenes son de días que todavía no llegan (${rango}). Entrarán en un Recibo cuando se cierren.`,
    periodoAbierto: (fin: string) =>
      `El periodo sigue abierto hasta el ${fin}. Lo que se cierre después de emitir irá en otro Recibo.`,
    abrirOrden: 'Abrir orden',
    col: {
      incluir: 'Incluir',
      fecha: 'Fecha',
      folio: 'Folio',
      servicio: 'Servicio',
      ruta: 'Ruta',
      barco: 'Barco',
      cap: 'Cap.',
      tarifa: 'Tarifa',
      cupon: 'Cupón',
      importe: 'Importe',
      cliente: 'Agencia',
      periodo: 'Periodo',
      emitido: 'Emitido',
      vence: 'Vence',
      total: 'Total',
      saldo: 'Saldo',
      estado: 'Estado',
      servicios: 'Servicios',
    },
    incluir: (f: string) => `Incluir ${f}`,
    capacidad: (cobrada: number, contratada: number) =>
      cobrada < contratada ? `${cobrada} de ${contratada}` : String(cobrada),
    capacidadAyuda: 'Se cobra la capacidad de la unidad enviada, menor a la contratada.',
    porServicio: 'Fijo',
    borrador: 'RECIBO · BORRADOR',
    folioAlEmitir: 'El folio se asigna al emitir',
    resumen: (cliente: string, periodo: string, vence: string) =>
      `${cliente} · ${periodo} · vence ${vence}`,
    servicios: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
    subtotal: 'Subtotal',
    iva: (pct: string) => `IVA ${pct} %`,
    total: 'Total MXN',
    tasasDistintas:
      'Los servicios elegidos tienen tasas de IVA distintas. Emite un Recibo por cada tasa.',
    emitir: 'Emitir Recibo',
    emitirAyuda: 'Después podrás descargar el PDF; el envío por correo y los pagos llegan después.',
    confirmarTitulo: 'Emitir Recibo',
    confirmar: (n: number, total: string, cliente: string) =>
      `Se emite un Recibo a ${cliente} por ${n === 1 ? '1 servicio' : `${n} servicios`} y ${total}. Un Recibo emitido no se edita: corregirlo es cancelarlo y emitir otro.`,
    emitido: 'Recibo emitido',
    emitidoSinPdf: 'Recibo emitido. El PDF no se generó: usa «Generar PDF».',
    errorEmitir: 'No se pudo emitir el Recibo. Intenta de nuevo.',
    errorPrevia: 'No se pudo armar la vista previa.',
    noEsCfdi: 'Este Recibo no es un comprobante fiscal (CFDI).',
    lista: 'Recibos',
    listaAyuda: 'Recibos emitidos, del más reciente al más viejo.',
    todas: 'Todas las agencias',
    todos: 'Todos',
    vigentes: 'Vigentes',
    cancelados: 'Cancelados',
    filtroEstado: 'Estado',
    vacio: 'Aún no hay Recibos',
    vacioAyuda: 'Emite el primero desde Nuevo Recibo.',
    vacioFiltro: 'Ningún Recibo coincide con el filtro',
    errorLista: 'No se pudieron cargar los Recibos.',
    pagina: (desde: number, hasta: number, total: number) => `${desde} a ${hasta} de ${total}`,
    anterior: 'Anterior',
    siguiente: 'Siguiente',
    detalle: {
      subtitulo: (periodo: string, servicios: string, emitido: string, vence: string) =>
        `${periodo} · ${servicios} · emitido ${emitido} · vence ${vence}`,
      vencido: (n: number) => (n === 1 ? 'vencido hace 1 día' : `vencido hace ${n} días`),
      pdf: 'PDF',
      generarPdf: 'Generar PDF',
      pdfGenerado: 'PDF generado',
      sinPdf: 'El PDF de este Recibo no se generó al emitir.',
      canceladoSinPdf: 'Se canceló antes de generar su PDF; queda sin PDF.',
      errorPdf: 'No se pudo abrir el PDF. Intenta de nuevo.',
      errorGenerarPdf: 'No se pudo generar el PDF. Intenta de nuevo.',
      cancelar: 'Cancelar Recibo',
      cancelarTitulo: (folio: string) => `Cancelar ${folio}`,
      cancelarImpacto: (n: number) =>
        `El Recibo queda cancelado y no se puede reactivar. ${n === 1 ? 'Su orden regresa' : `Sus ${n} órdenes regresan`} a Cerrada para emitir un Recibo corregido. El PDF se conserva como historia.`,
      motivos: {
        servicios: 'Servicios equivocados',
        importes: 'Importes equivocados',
        cliente: 'Datos del cliente',
        otro: 'Otro',
      },
      cancelado: 'Recibo cancelado. Sus órdenes regresaron a Cerrada.',
      errorCancelar: 'No se pudo cancelar el Recibo.',
      canceladoAviso: (fecha: string, motivo: string) => `Cancelado el ${fecha}. Motivo: ${motivo}`,
      desglose: 'Desglose',
      modoGrupos: 'Por servicio',
      modoDetalle: 'Servicio por servicio',
      grupoMeta: (n: number) => (n === 1 ? '1 servicio' : `${n} servicios`),
      saldo: 'SALDO',
      pagado: (pagado: string, total: string) => `${pagado} pagado de ${total}`,
      pagos: 'Pagos aplicados',
      sinPagos: 'Sin pagos registrados.',
      historial: 'Historial',
      evento: {
        emitido: (quien: string) => `Emitido por ${quien}`,
        cancelado: (quien: string) => `Cancelado por ${quien}`,
      },
      alguien: 'alguien',
      cfdi: 'Referencia del CFDI',
      cfdiAyuda: 'Folio o UUID del CFDI timbrado en CONTPAQi. Solo referencia.',
      cfdiGuardar: 'Guardar',
      cfdiGuardado: 'Referencia guardada',
      cfdiSin: 'Sin referencia',
      errorCfdi: 'No se pudo guardar la referencia.',
      error: 'No se pudo cargar el Recibo.',
      volver: 'Recibos',
      registrarPago: 'Registrar pago',
      pagoLinea: (fecha: string, referencia: string | null) =>
        referencia ? `${fecha} · ${referencia}` : fecha,
      pagoRevertido: 'Revertido',
      conPagos: 'Tiene pagos aplicados: para cancelarlo, revierte primero esos pagos.',
      correo: {
        titulo: 'Correo a la agencia',
        enviar: 'Enviar por correo',
        reenviar: 'Reenviar',
        para: (correo: string) => `Para ${correo}`,
        confirmarTitulo: (folio: string) => `Enviar ${folio}`,
        confirmarTexto: (correo: string) =>
          `Se manda a ${correo} con el PDF del Recibo adjunto, el total, el saldo y el vencimiento.`,
        confirmar: 'Enviar',
        cancelar: 'Cancelar',
        enviado: (correo: string) => `Recibo enviado a ${correo}`,
        error: 'No se pudo enviar el Recibo.',
        sinCorreo:
          'La agencia no tiene correo de cobranza. Agrégalo en Catálogos para enviarle el Recibo.',
        sinEnvios: 'Todavía no se ha enviado por correo.',
        cancelado: 'Un Recibo cancelado ya no se envía.',
        linea: (quien: string, cuando: string) => `${quien} · ${cuando}`,
        alguien: 'alguien',
        estado: {
          enviando: 'Enviando',
          enviado: 'Enviado',
          entregado: 'Entregado',
          rebotado: 'Rebotó',
          fallido: 'No salió',
        },
        rebotoTitulo: 'El último correo no llegó',
        rebotoTexto: (correo: string, motivo: string) =>
          `El correo a ${correo} rebotó: ${motivo}. Revisa el correo de cobranza en Catálogos y reenvía.`,
        fallidoTexto: (motivo: string) => `El último envío no salió: ${motivo}.`,
        errorCarga: 'No se pudieron cargar los envíos.',
      },
    },
  },
  pagos: {
    migas: 'Liquidación',
    lista: 'Pagos',
    listaAyuda: 'Depósitos de las agencias, del más reciente al más viejo.',
    nuevo: 'Registrar pago',
    nuevoAyuda:
      'Captura el depósito. Se aplica primero al Recibo más antiguo; puedes cambiar el reparto antes de guardar. Lo que sobre queda a favor de la agencia.',
    agencia: 'Agencia',
    todas: 'Todas las agencias',
    filtroEstado: 'Estado',
    todos: 'Todos',
    estado: {
      aplicado: 'Aplicado',
      a_favor: 'Con saldo a favor',
      revertido: 'Revertido',
    },
    col: {
      fecha: 'Fecha',
      agencia: 'Agencia',
      referencia: 'Referencia',
      monto: 'Monto',
      aplicado: 'Aplicado',
      aFavor: 'A favor',
      recibos: 'Recibos',
      estado: 'Estado',
      recibo: 'Recibo',
      emitido: 'Emitido',
      vence: 'Vence',
      total: 'Total',
      saldo: 'Saldo',
      aplicar: 'Aplicar',
    },
    vacio: 'Aún no hay pagos',
    vacioAyuda: 'Registra el primero cuando llegue un depósito.',
    vacioFiltro: 'Ningún pago coincide con el filtro',
    errorLista: 'No se pudieron cargar los pagos.',
    pagina: (desde: number, hasta: number, total: number) => `${desde} a ${hasta} de ${total}`,
    anterior: 'Anterior',
    siguiente: 'Siguiente',
    saldosAFavor: 'Saldo a favor por agencia',
    saldosAFavorAyuda: 'Lo que las agencias depositaron de más y falta aplicar a un Recibo.',
    verPagos: (n: number) => (n === 1 ? 'Ver 1 pago' : `Ver ${n} pagos`),
    form: {
      fecha: 'Fecha del depósito',
      monto: 'Monto depositado',
      referencia: 'Referencia bancaria (opcional)',
      referenciaAyuda: 'La del estado de cuenta del banco. Sirve para avisar si ya se registró.',
      comprobante: 'Comprobante (opcional)',
      comprobanteAyuda: 'PDF o foto del depósito, hasta 10 MB. Se guarda privado.',
      agregarComprobante: 'Adjuntar comprobante',
      quitarComprobante: (n: string) => `Quitar ${n}`,
      elegirAgencia: 'Elige la agencia para ver sus Recibos con saldo.',
      capturaMonto: 'Captura el monto para repartirlo entre sus Recibos.',
      reparto: 'Reparto entre Recibos',
      repartoAyuda: 'Primero al más antiguo. Cambia los montos si la agencia indicó otro reparto.',
      sugerido: 'Volver al reparto sugerido',
      sinRecibos: 'La agencia no tiene Recibos con saldo. Todo el pago quedará a favor.',
      aplicado: 'Aplicado a Recibos',
      aFavor: 'Queda a favor',
      excedePago: 'Lo repartido pasa del monto del pago.',
      excedeRecibo: 'Un monto pasa del saldo de su Recibo.',
      ajenos:
        'Algún Recibo del reparto ya no tiene saldo o se canceló. Vuelve al reparto sugerido.',
      favorPrevio: (monto: string) =>
        `Esta agencia ya tiene ${monto} a favor de pagos anteriores. Puedes aplicarlo desde esos pagos.`,
      repetidaTitulo: 'Esta referencia ya está registrada',
      repetida: (fecha: string, agencia: string, monto: string) =>
        `${fecha} · ${agencia} · ${monto}`,
      repetidaOk: 'Es otro depósito: registrarlo de todos modos',
      guardar: 'Registrar pago',
      guardando: 'Registrando…',
      registrado: 'Pago registrado',
      errores: {
        agencia: 'Elige la agencia.',
        fecha: 'Elige la fecha del depósito.',
        monto: 'Escribe el monto en pesos, mayor a cero y con hasta dos decimales.',
        montoRecibo: 'Monto en pesos con hasta dos decimales.',
        comprobante: 'El comprobante es un PDF o una foto de hasta 10 MB.',
        repetida: 'Confirma que es otro depósito o corrige la referencia.',
        generico: 'No se pudo registrar el pago. Intenta de nuevo.',
      },
    },
    detalle: {
      titulo: (monto: string) => `Pago de ${monto}`,
      subtitulo: (agencia: string, fecha: string, referencia: string | null) =>
        [agencia, `depositado el ${fecha}`, referencia].filter(Boolean).join(' · '),
      aplicadoA: 'Aplicado a',
      sinAplicaciones: 'Todavía no se aplica a ningún Recibo.',
      aFavor: 'SALDO A FAVOR',
      aFavorDe: (aplicado: string, monto: string) => `${aplicado} aplicado de ${monto}`,
      aplicarSaldo: 'Aplicar saldo a favor',
      aplicarTitulo: 'Aplicar saldo a favor',
      aplicarAyuda: (monto: string) =>
        `Hay ${monto} disponibles. Se sugiere al Recibo abierto más antiguo; puedes cambiarlo.`,
      aplicar: 'Aplicar',
      aplicado: 'Saldo aplicado',
      errorAplicar: 'No se pudo aplicar el saldo.',
      sinRecibosAbiertos: 'La agencia no tiene Recibos con saldo por ahora.',
      comprobante: 'Ver comprobante',
      sinComprobante: 'Sin comprobante',
      errorComprobante: 'No se pudo abrir el comprobante. Intenta de nuevo.',
      repetidos: 'Otros pagos con la misma referencia',
      revertir: 'Revertir pago',
      revertirTitulo: (monto: string) => `Revertir pago de ${monto}`,
      revertirImpacto: (n: number) =>
        n === 0
          ? 'El pago queda revertido y ya no cuenta. Se conserva como historia.'
          : `El pago queda revertido y ya no cuenta. ${n === 1 ? 'El Recibo al que se aplicó recupera' : `Los ${n} Recibos a los que se aplicó recuperan`} su saldo. Se conserva como historia.`,
      motivos: {
        rebotado: 'Depósito rebotado',
        duplicado: 'Registrado dos veces',
        captura: 'Error de captura',
        otro: 'Otro',
      },
      revertido: 'Pago revertido. Sus Recibos recuperaron su saldo.',
      errorRevertir: 'No se pudo revertir el pago.',
      revertidoAviso: (fecha: string, motivo: string) => `Revertido el ${fecha}. Motivo: ${motivo}`,
      historial: 'Historial',
      evento: {
        registrado: (quien: string, monto: string) => `Registrado por ${quien} (${monto})`,
        aplicado: (quien: string, monto: string) => `${quien} aplicó ${monto} del saldo a favor`,
        revertido: (quien: string) => `Revertido por ${quien}`,
      },
      alguien: 'alguien',
      error: 'No se pudo cargar el pago.',
      volver: 'Pagos',
    },
  },
  asignar: {
    tituloAsignar: (folio: string) => `Asignar unidad a ${folio}`,
    tituloCambiar: (folio: string) => `Cambiar unidad u operador de ${folio}`,
    subtitulo: (agencia: string, referencia: string, pax: number | null, horario: string) =>
      `${agencia} · ${referencia}${pax === null ? '' : ` · ${pax} pax`} · ${horario}`,
    horario: (sale: string, regresa: string | null) =>
      regresa ? `de ${sale} a ${regresa}` : `sale ${sale}`,
    liberando: (unidad: string, folio: string) =>
      `Mueve esta orden para liberar ${unidad} para ${folio}.`,
    cargando: 'Buscando unidades…',
    unaUnidad: 'Una orden va siempre en una sola unidad.',
    causaOcupadas: (pax: number) =>
      `Ninguna unidad libre tiene ${pax} lugares a esa hora: las que alcanzan ya tienen servicio.`,
    causaNinguna: (pax: number) => `Ninguna unidad activa tiene ${pax} lugares.`,
    salidaCausa:
      'Libera una que alcance moviendo primero su servicio, corrige los pasajeros si el cliente confirmó menos, o déjala sin unidad por ahora.',
    masContratado: (pax: number, contratados: number) =>
      `Lleva más de lo contratado: ${pax} pasajeros y ${contratados} lugares contratados.`,
    masContratadoAyuda: 'No impide asignarla. Si el cliente confirmó menos, corrígelo en Editar.',
    yaSalio: 'Esta orden ya no se reasigna desde aquí.',
    verOrden: 'Ver orden',
    grupos: {
      actual: 'Unidad actual',
      libre: 'Libres y alcanzan',
      ocupada: 'Alcanzan, pero ya tienen servicio',
      ocupadaAyuda: 'mueve primero ese servicio y esta orden toma su lugar',
      no_cabe: 'Libres, pero no caben',
      noCabeAyuda: 'una orden va en una sola unidad; estas no se pueden elegir',
      quitar: 'Sin unidad',
    },
    unidad: (numero: string, tipo: string, lugares: number) =>
      `${numero} · ${tipo} · ${lugares} lugares`,
    sobran: (n: number) => (n === 0 ? 'justo' : `sobran ${n}`),
    faltan: (n: number) => `no caben ${n}`,
    actual: 'La que tiene ahora.',
    libre: 'Libre en ese horario.',
    margen: (min: number) => `Termina ${min} min antes del regreso que ya tiene esa unidad.`,
    justo: (min: number) => `Cuidado: solo quedan ${min} min antes del regreso de esa unidad.`,
    ocupada: (desde: string, hasta: string, folio: string, agencia: string, pax: number) =>
      `Ocupada de ${desde} a ${hasta} con ${folio} (${agencia}, ${pax} pax).`,
    cabeEnOtra: (folio: string) => `${folio} cabe en otra unidad.`,
    noCabeEnOtra: (folio: string) => `${folio} no cabe en otra unidad a esa hora.`,
    variosChoques: (n: number) =>
      `Y ${n === 1 ? 'otro servicio' : `${n} servicios más`}: mover uno no la libera.`,
    noCabe: (n: number) => `Libre, pero faltan ${n} lugares.`,
    quitarDesc: 'Queda sin unidad ni operador y vuelve a Sin asignar.',
    operador: 'Operador',
    sinOperador: 'Sin operador por ahora',
    operadorOtraFlota: 'La unidad es de otra flota: el operador se elige entre los de esa flota.',
    eligeOperador: 'Elige un operador para guardar.',
    sugerir: 'Sugerir por rotación',
    sugerida: (u: string, o: string) => `Sugerida: ${u} · ${o}`,
    sinSugerencia: 'La rotación no encontró unidad y operador libres para esta orden.',
    motivo: 'Motivo (opcional)',
    resumen: {
      asignar: (folio: string, unidad: string, operador: string | null, horario: string) =>
        `${folio} va en ${unidad}${operador ? ` con ${operador}` : ''}, ${horario}.`,
      operador: (folio: string, operador: string | null) =>
        operador
          ? `${folio} sigue en su unidad, ahora con ${operador}.`
          : `${folio} sigue en su unidad, sin operador.`,
      moverPrimero: (otra: string, unidad: string, folio: string) =>
        `Primero se mueve ${otra} a otra unidad; después ${unidad} queda libre para ${folio}.`,
      quitar: (folio: string) => `${folio} queda sin unidad y vuelve a Sin asignar.`,
      sinCambios: 'No hay cambios que guardar.',
      nada: 'Ninguna unidad sirve ahora. La orden puede quedarse sin unidad mientras se resuelve.',
    },
    boton: {
      asignar: (unidad: string, operador: string | null) =>
        operador ? `Asignar ${unidad} y ${operador}` : `Asignar ${unidad}`,
      mover: (unidad: string, operador: string | null) =>
        operador ? `Mover a ${unidad} con ${operador}` : `Mover a ${unidad}`,
      operador: (operador: string | null) =>
        operador ? `Cambiar operador a ${operador}` : 'Quitar el operador',
      moverPrimero: (folio: string) => `Mover primero ${folio}`,
      quitar: 'Quitarle la unidad',
      sinCambios: 'Sin cambios',
      dejarSin: 'Dejarla sin unidad por ahora',
      cancelar: 'Cancelar',
      regresar: (folio: string) => `Regresar a ${folio}`,
    },
    guardada: (folio: string) => `${folio}: asignación guardada`,
    error: 'No se pudo guardar la asignación',
  },
  selectorBuscable: {
    elegir: 'Elige una opción',
    buscar: 'Buscar',
    sinResultados: 'Nada coincide',
  },
  stepper: { menos: 'Menos', mas: 'Más' },
  dialogo: { cerrar: 'Cerrar' },
  inicio: {
    titulo: 'Inicio',
    saludo: { manana: 'Buenos días', tarde: 'Buenas tardes', noche: 'Buenas noches' },
    /** La frase de estado de mañana. La cuenta de pasos la hace la base. */
    frase: {
      sinServicios: 'Mañana todavía no hay servicios.',
      listo: (n: number) =>
        n === 1
          ? 'Mañana hay 1 servicio y ya está listo.'
          : `Mañana hay ${n} servicios y ya está listo.`,
      falta: (n: number, listos: number) =>
        `Mañana hay ${n === 1 ? '1 servicio' : `${n} servicios`}: van ${listos} de 4 pasos para dejarlo listo.`,
      cobranza: 'Esto es lo que toca hoy de cierre y cobranza.',
    },
    preparar: {
      etiqueta: 'Preparar mañana',
      eyebrow: (dia: string) => `PREPARAR MAÑANA · ${dia.toUpperCase()}`,
      listos: (n: number) => `${n} de 4 pasos listos`,
      estado: { hecho: 'Hecho', ahora: 'Paso actual', despues: 'Después' },
      deTotal: (titulo: string, n: number, de: number) => `${titulo} · ${n} de ${de}`,
      sinOrdenesAun: 'Cuando haya órdenes de mañana.',
      confirmar: {
        titulo: 'Confirmar con los clientes',
        vacio: 'Captura o clona las órdenes de mañana.',
        vacioCta: 'Capturar o clonar',
        hecho: (n: number) =>
          n === 1
            ? 'La orden de mañana ya está confirmada.'
            : `Las ${n} órdenes de mañana ya están confirmadas.`,
        falta: (n: number) =>
          n === 1
            ? 'Falta 1 borrador por confirmar con su agencia. Sin confirmar no lleva folio ni se imprime.'
            : `Faltan ${n} borradores por confirmar con su agencia. Sin confirmar no llevan folio ni se imprimen.`,
        cta: 'Ir a Por confirmar',
      },
      alertas: {
        titulo: 'Revisar alertas',
        limpio: 'Sin traslapes ni regresos justos.',
        soloAvisos: (n: number) =>
          n === 1
            ? 'Nada bloquea. Hay 1 regreso justo: revísalo en el tablero.'
            : `Nada bloquea. Hay ${n} regresos justos: revísalos en el tablero.`,
        bloqueos: (partes: string[]) => `${partes.join(' · ')}. Se corrigen en el tablero.`,
        traslape: (n: number) => (n === 1 ? '1 traslape' : `${n} traslapes`),
        capacidad: (n: number) =>
          n === 1
            ? '1 unidad con menos lugares que pasajeros'
            : `${n} unidades con menos lugares que pasajeros`,
        unidad_en_taller: (n: number) =>
          n === 1 ? '1 unidad en taller con servicio' : `${n} unidades en taller con servicio`,
        regreso_justo: (n: number) => (n === 1 ? '1 regreso justo' : `${n} regresos justos`),
        cta: 'Ver alertas en el tablero',
      },
      asignar: {
        titulo: 'Asignar unidad y operador',
        hecho: 'Todas tienen unidad y operador.',
        una: (folio: string, cliente: string, causa: string) =>
          `Falta ${folio} de ${cliente}: ${causa}`,
        varias: (n: number, folio: string, cliente: string, causa: string) =>
          `Faltan ${n}. Empieza por ${folio} de ${cliente}: ${causa}`,
        sinFolio: (referencia: string) => `el borrador ${referencia}`,
        resolver: (folio: string) => `Resolver ${folio}`,
        cta: 'Asignar en el tablero',
      },
      imprimir: {
        titulo: 'Imprimir órdenes y rol',
        hecho: 'Las órdenes y el rol están impresos en su última versión.',
        faltan: (n: number, cambiaron: number) =>
          (n === 1 ? 'Falta 1 hoja por imprimir.' : `Faltan ${n} hojas por imprimir.`) +
          (cambiaron > 0
            ? cambiaron === 1
              ? ' Una cambió después de imprimirse.'
              : ` ${cambiaron} cambiaron después de imprimirse.`
            : ''),
        faltaRol: 'Las órdenes ya están impresas. Falta imprimir el rol del día.',
        rolViejo: (v: number) => `El rol v${v} cambió después de imprimirse: imprímelo otra vez.`,
        despues: 'Se imprime cuando todo tiene unidad.',
        listas: (n: number) =>
          n === 1
            ? ' Puedes imprimir la que ya está lista.'
            : ` Puedes imprimir las ${n} listas ahora.`,
        ctaOrdenes: (n: number) => (n === 1 ? 'Imprimir la orden' : `Imprimir las ${n} órdenes`),
        ctaListas: (n: number) => (n === 1 ? 'Imprimir la lista' : `Imprimir las ${n} listas`),
        ctaRol: 'Imprimir rol',
      },
    },
    licencias: {
      titulo: 'Licencias de choferes',
      ayuda:
        'Una licencia vencida impide asignar al chofer a servicios posteriores. Aquí salen las que ya vencieron y las que vencen en el próximo mes.',
      vencida: 'Vencida',
      vence: (dias: number) =>
        dias === 0 ? 'Vence hoy' : dias === 1 ? 'Vence mañana' : `Vence en ${dias} días`,
      hasta: (f: string) => `Vigente hasta el ${f}`,
      servicios: (n: number) =>
        n === 1 ? '1 servicio asignado después' : `${n} servicios asignados después`,
      sinCaptura: (n: number) =>
        n === 1
          ? '1 chofer activo no tiene la fecha de su licencia.'
          : `${n} choferes activos no tienen la fecha de su licencia.`,
      capturar: 'Capturarlas',
      ver: 'Ver choferes',
      todo: 'Todas las licencias están al corriente.',
    },
    cerrar: {
      titulo: 'Días que faltan por cerrar',
      ayuda: 'Un servicio sin cerrar no se puede cobrar. Empieza por el más antiguo.',
      todo: 'Todo cerrado: no quedan días pasados por cerrar.',
      servicios: (n: number) => (n === 1 ? '1 servicio por cerrar' : `${n} servicios por cerrar`),
      clientes: (n: number) => (n === 1 ? '1 cliente' : `${n} clientes`),
      masAntiguo: 'El más antiguo',
      cta: 'Cerrar',
      irA: (dia: string) => `Cerrar el ${dia}`,
    },
    cobranza: {
      etiqueta: 'Cobranza',
      eyebrow: 'COBRANZA',
      quincena: (primera: boolean, mes: string) => `${primera ? '1.ª' : '2.ª'} quincena de ${mes}`,
      titulo: (periodo: string, n: number) =>
        n === 1
          ? `${periodo}: 1 servicio cerrado listo para Recibo`
          : `${periodo}: ${n} servicios cerrados listos para Recibo`,
      importe: (clientes: number, importe: string) =>
        `De ${clientes === 1 ? '1 cliente' : `${clientes} clientes`} · ${importe} antes de IVA.`,
      ninguno: 'Todavía no hay servicios cerrados sin Recibo en esta quincena.',
      porCerrar: (n: number) =>
        n === 1
          ? '1 servicio más se suma cuando se cierre.'
          : `${n} servicios más se suman cuando se cierren.`,
      conAlerta: (n: number) =>
        n === 1
          ? '1 cerrado no entra: le falta tarifa o cupón.'
          : `${n} cerrados no entran: les falta tarifa o cupón.`,
      cta: 'Generar recibos',
      error: 'No se pudo cargar la cobranza.',
    },
    numeros: {
      titulo: 'Mañana en números',
      servicios: 'servicios',
      pasajeros: 'pasajeros',
      unidades: 'Unidades ocupadas',
      flota: (nombre: string, codigo: string) => `${nombre} (${codigo})`,
      deTotal: (n: number, de: number, llena: boolean) =>
        `${n} de ${de}${llena ? ' · llenas' : ''}`,
    },
    semana: {
      titulo: 'Esta semana',
      ayuda: 'servicios por día',
      dia: (dia: string, n: number) => `${dia}: ${n === 1 ? '1 servicio' : `${n} servicios`}`,
    },
  },
  cartera: {
    migas: 'Liquidación',
    titulo: 'Cartera',
    ayuda:
      'Lo que cada agencia debe, por antigüedad desde la emisión del Recibo. Un Recibo pasa a Vencido al día siguiente de su vencimiento.',
    resumen: (saldo: string, vencido: string) => `${saldo} por cobrar · ${vencido} vencido`,
    aFavorTotal: (monto: string) => `${monto} a favor de agencias`,
    generado: (cuando: string) => `Generado el ${cuando}`,
    filtro: 'Estado',
    todas: 'Todas',
    cubeta: {
      a15: '0 a 15 días',
      a30: '16 a 30',
      a60: '31 a 60',
      a60mas: 'Más de 60',
    },
    col: {
      agencia: 'Agencia',
      recibos: 'Recibos',
      saldo: 'Saldo',
      vencido: 'Vencido',
      aFavor: 'A favor',
      estado: 'Estado',
      desde: 'Debe desde',
      total: 'Total',
      recibo: 'Recibo',
      emitido: 'Emitido',
      vence: 'Vence',
      pagado: 'Pagado',
      antiguedad: 'Días',
      fecha: 'Fecha',
      referencia: 'Referencia',
      monto: 'Monto',
    },
    meta: {
      vencidos: (n: number) => (n === 1 ? '1 Recibo vencido' : `${n} Recibos vencidos`),
      recibos: (n: number) => (n === 1 ? '1 Recibo con saldo' : `${n} Recibos con saldo`),
      vence: (dia: string) => `vence ${dia}`,
      alCorriente: 'Al corriente',
      desde: (dia: string) => `debe desde ${dia}`,
    },
    verEstado: 'Estado de cuenta',
    excel: 'Excel',
    exportando: 'Preparando…',
    errorExcel: 'No se pudo preparar el Excel. Intenta de nuevo.',
    vacio: 'Ninguna agencia debe nada',
    vacioFiltro: 'Ninguna agencia en este estado',
    vacioAyuda: 'Aquí aparecen las agencias en cuanto se emite su primer Recibo.',
    errorCarga: 'No se pudo cargar la cartera.',
    estadoCuenta: {
      titulo: 'Estado de cuenta',
      hoja: 'Estado de cuenta',
      volver: 'Volver',
      imprimir: 'Imprimir o PDF',
      excel: 'Excel',
      correo: 'Enviar por correo',
      correoPendiente:
        'El envío por correo llega con la conexión de correo (Resend). Mientras tanto, descarga el PDF o el Excel y mándalo desde tu correo.',
      correoA: (correo: string) => `Se enviará a ${correo}`,
      sinCorreo: 'La agencia no tiene correo de cobranza en Catálogos.',
      ayuda: 'Para guardarlo en PDF, elige «Guardar como PDF» en el diálogo de impresión.',
      fecha: (dia: string) => `Al ${dia}`,
      saldo: 'Saldo por pagar',
      vencido: 'Vencido',
      aFavor: 'Pagos con saldo a favor',
      aFavorNota: 'Este saldo a favor se aplicará a tus Recibos pendientes.',
      recibos: 'Recibos con saldo',
      sinRecibos: 'Sin Recibos pendientes. La agencia está al corriente.',
      deposito: 'Datos para depositar',
      noFiscal: 'Este documento no es un comprobante fiscal (CFDI).',
      vencidoHace: (n: number) => (n === 1 ? 'vencido hace 1 día' : `vencido hace ${n} días`),
      errorCarga: 'No se pudo cargar el estado de cuenta.',
      archivo: (agencia: string, dia: string) => `Estado de cuenta ${agencia} ${dia}`,
    },
  },
  contpaqi: {
    migas: 'Liquidación',
    titulo: 'Reporte para CONTPAQi',
    ayuda:
      'Recibos y pagos del periodo, en el orden de captura. Marca cada renglón cuando ya esté en CONTPAQi. Los importes son los de Uniper Ops, sin rehacer cuentas.',
    periodo: 'Periodo',
    quincenaAnterior: 'Quincena anterior',
    maxDias: 'Hasta 92 días por reporte.',
    filtro: 'Mostrar',
    filtros: { todos: 'Todos', pendientes: 'Por capturar', capturados: 'Capturados' },
    pestanas: 'Recibos o pagos',
    pestana: {
      recibos: (n: number) => `Recibos · ${n}`,
      pagos: (n: number) => `Pagos · ${n}`,
    },
    progreso: (n: number, total: number) => `${n} de ${total} capturados`,
    csv: 'Descargar CSV',
    excel: 'Descargar Excel',
    exportando: 'Preparando…',
    errorArchivo: 'No se pudo preparar el archivo. Intenta de nuevo.',
    errorCarga: 'No se pudo cargar el reporte.',
    errorMarcar: 'No se pudo guardar la marca. Intenta de nuevo.',
    vacio: {
      recibos: 'No se emitieron Recibos en este periodo',
      pagos: 'No se registraron pagos en este periodo',
      filtro: 'Nada en este filtro',
    },
    noEsCfdi:
      'Uniper Ops no timbra: el CFDI se timbra a mano en CONTPAQi y aquí solo se anota su folio o UUID.',
    capturado: 'Capturado',
    marcar: (que: string) => `Marcar ${que} como capturado en CONTPAQi`,
    capturadoPor: (quien: string, cuando: string) => `Capturado por ${quien}, ${cuando}`,
    si: 'Sí',
    no: 'No',
    cfdi: {
      columna: 'CFDI',
      titulo: (que: string) => `CFDI de ${que}`,
      campo: 'Folio o UUID del CFDI',
      ayuda: 'Opcional. Déjalo vacío para quitarlo.',
      agregar: 'Anotar',
      editar: 'Editar CFDI',
      guardar: 'Guardar',
      cancelar: 'Cancelar',
      guardado: 'CFDI guardado',
      error: 'No se pudo guardar el CFDI.',
      sinEditar: 'Ya no cambia',
    },
    estado: {
      vigente: 'Vigente',
      cancelado: 'Cancelado',
    },
    canceladoEl: (dia: string) => `cancelado ${dia}`,
    pago: (agencia: string, dia: string) => `el pago de ${agencia} del ${dia}`,
    col: {
      fecha: 'Fecha',
      serie: 'Serie',
      folio: 'Folio',
      serieFolio: 'Serie y folio',
      agencia: 'Agencia',
      razonSocial: 'Razón social',
      rfc: 'RFC',
      periodo: 'Periodo',
      servicios: 'Servicios',
      subtotal: 'Subtotal',
      tasaIva: 'Tasa IVA',
      iva: 'IVA',
      total: 'Total',
      estado: 'Estado',
      referencia: 'Referencia',
      aplicadoA: 'Aplicado a',
      monto: 'Monto',
      aplicado: 'Aplicado',
      aFavor: 'A favor',
      capturadoPor: 'Capturado por',
      capturadoEl: 'Capturado el',
    },
    pie: {
      subtotal: 'Subtotal',
      iva: 'IVA',
      total: 'Total',
      cobrado: 'Total cobrado',
      aFavor: 'A favor',
      nota: 'Sin Recibos cancelados ni pagos revertidos.',
    },
    hoja: { recibos: 'Recibos', pagos: 'Pagos' },
    archivo: (que: string, desde: string, hasta: string) => `contpaqi-${que}-${desde}-al-${hasta}`,
    generado: (cuando: string) => `Generado el ${cuando}`,
    periodoTexto: (texto: string) => `Periodo: ${texto}`,
    filtroTexto: (texto: string) => `Mostrando: ${texto}`,
  },
  reportes: {
    migas: 'Administración',
    titulo: 'Reportes',
    encabezado: 'Cómo va la operación',
    ayuda:
      'Servicios, uso de la flota y equidad en la rotación de choferes por periodo. Cuenta los servicios confirmados, en curso, cerrados y facturados por su fecha de servicio.',
    ayudaDinero: 'Los ingresos son sin IVA, de los mismos servicios.',
    periodo: 'Periodo',
    ultimos30: 'Últimos 30 días',
    maxDias: 'Hasta 92 días por reporte.',
    pestanas: 'Tipo de reporte',
    pestana: { operativos: 'Operativos', financieros: 'Financieros' },
    imprimir: 'Imprimir o PDF',
    excel: 'Descargar Excel',
    exportando: 'Preparando…',
    correo: 'Enviar por correo',
    correoPendiente:
      'El envío por correo se activa cuando el servidor arme el PDF del reporte. Mientras, guárdalo en PDF o Excel y mándalo a mano.',
    errorCarga: 'No se pudo cargar el reporte.',
    errorExcel: 'No se pudo preparar el Excel. Intenta de nuevo.',
    vacio: 'No hay servicios en este periodo.',
    generado: (cuando: string) => `Generado el ${cuando}`,
    periodoTexto: (texto: string) => `Periodo: ${texto}`,
    archivo: (que: string, desde: string, hasta: string) => `reporte-${que}-${desde}-al-${hasta}`,
    variacion: (pct: number) =>
      `${pct > 0 ? '+' : ''}${pct.toLocaleString('es-MX')} % contra los días previos`,
    sinComparar: 'Sin servicios en los días previos para comparar',
    kpi: {
      servicios: 'Servicios',
      pax: 'Pax trasladados',
      paxPromedio: (n: number | null, con: number, de: number) =>
        n === null
          ? 'Sin pax capturado'
          : `${n.toLocaleString('es-MX')} por servicio · capturado en ${con} de ${de}`,
      conPax: 'Servicios con pax capturado',
      cancelaciones: 'Cancelaciones',
      noShows: 'No shows',
      diasConServicio: (n: number) => (n === 1 ? '1 día con servicio' : `${n} días con servicio`),
      ingresos: 'Ingresos sin IVA',
      promedio: 'Promedio por servicio',
      sinTarifa: (n: number) =>
        n === 1 ? '1 servicio sin tarifa no suma' : `${n} servicios sin tarifa no suman`,
      conTarifa: 'De los servicios con tarifa',
      carteraVencida: 'Cartera vencida',
      agenciasVencidas: (n: number) =>
        n === 1 ? '1 agencia, al día de hoy' : `${n} agencias, al día de hoy`,
    },
    grafica: {
      servicios: 'Servicios por día',
      ingresos: 'Ingresos por día, sin IVA',
      dia: (dia: string, valor: string) => `${dia}: ${valor}`,
    },
    ocupacion: {
      titulo: 'Ocupación de flota · promedio diario',
      ayuda: 'Unidades usadas en promedio en los días con servicio, contra las unidades activas.',
      tipos: { bus: 'Buses', van: 'Vans', open_top: 'Open Top' },
      grupo: (codigo: string, tipo: string) => `${tipo} ${codigo}`,
      uso: (promedio: number, total: number) => `${promedio.toLocaleString('es-MX')} de ${total}`,
      maximo: (n: number, dia: string) => `Máximo ${n} el ${dia}`,
      sinUso: 'Sin uso en el periodo',
      vacio: 'No hay unidades activas.',
    },
    rotacion: {
      titulo: 'Rotación de choferes',
      ayuda:
        'Salidas de cada chofer en el periodo, dentro de su flota. Entre más juntos los números, más pareja la rotación.',
      rango: (min: number, max: number) => `de ${min} a ${max} salidas`,
      salidas: (n: number) => (n === 1 ? '1 salida' : `${n} salidas`),
      inactivo: 'inactivo',
      vacio: 'No hay choferes en esta flota.',
    },
    cancelaciones: {
      titulo: 'Cancelaciones y no shows por agencia',
      agencia: 'Agencia',
      servicios: 'Servicios',
      cancelaciones: 'Cancelaciones',
      noShows: 'No shows',
      porcentaje: '% de lo pedido',
      vacio: 'Ninguna agencia pidió servicios en el periodo.',
    },
    desglose: {
      agencia: 'Ingresos por agencia',
      referencia: 'Ingresos por referencia del cliente',
      unidad: 'Ingresos por unidad',
      unidadAyuda: 'La unidad con la que se pactó el precio; un rescate no mueve el ingreso.',
      barco: 'Ingresos por barco',
      nombre: 'Nombre',
      servicios: 'Servicios',
      ingresos: 'Ingresos sin IVA',
      serviciosN: (n: number) =>
        n === 1 ? '1 servicio' : `${n.toLocaleString('es-MX')} servicios`,
      sinUnidad: 'Sin unidad',
      sinBarco: 'Sin barco',
      vacio: 'Sin ingresos en el periodo.',
    },
    cartera: {
      titulo: 'Cartera vencida',
      ayuda: 'Al día de hoy, sin importar el periodo. El detalle está en Cartera.',
      ver: 'Ver cartera',
      dias: (n: number) => (n === 1 ? '1 día vencido' : `${n} días vencido`),
      vacio: 'Ninguna agencia tiene saldo vencido.',
    },
    hojas: {
      resumen: 'Resumen',
      porDia: 'Por día',
      ocupacion: 'Ocupación',
      rotacion: 'Rotación',
      cancelaciones: 'Cancelaciones',
      agencias: 'Agencias',
      referencias: 'Referencias',
      unidades: 'Unidades',
      barcos: 'Barcos',
      cartera: 'Cartera vencida',
    },
    col: {
      concepto: 'Concepto',
      valor: 'Valor',
      dia: 'Día',
      flota: 'Flota',
      tipo: 'Tipo',
      activas: 'Unidades activas',
      promedio: 'Promedio diario',
      porcentaje: '% de uso',
      maximo: 'Máximo',
      diaMaximo: 'Día del máximo',
      operador: 'Chofer',
      salidas: 'Salidas',
      activo: 'Activo',
      dias: 'Días vencido',
      vencido: 'Vencido',
      anterior: 'Días previos',
      variacion: 'Variación %',
    },
    si: 'Sí',
    no: 'No',
  },
  nav: {
    operacion: 'OPERACIÓN',
    liquidacion: 'LIQUIDACIÓN',
    administracion: 'ADMINISTRACIÓN',
    inicio: 'Inicio',
    tablero: 'Tablero del día',
    ordenes: 'Órdenes',
    porConfirmar: 'Por confirmar',
    cierre: 'Cierre del día',
    incidentes: 'Incidentes',
    nuevoRecibo: 'Nuevo Recibo',
    recibos: 'Recibos',
    pagos: 'Pagos',
    cartera: 'Cartera',
    contpaqi: 'Reporte CONTPAQi',
    reportes: 'Reportes',
    catalogos: 'Catálogos',
    configuracion: 'Configuración',
    principal: 'Principal',
    abrirMenu: 'Abrir menú',
    pendientes: (n: number) =>
      n === 1 ? '1 borrador por confirmar' : `${n} borradores por confirmar`,
  },
  comun: {
    cargando: 'Cargando…',
    errorGenerico: 'Algo salió mal. Intenta de nuevo.',
    noEncontrado: 'Esta página no existe.',
    irAlInicio: 'Ir al inicio',
    /** R-26: la lista tiene tope y hay más de lo que se ve. */
    mostrando: (n: number, total: number) =>
      `Mostrando ${n.toLocaleString('es-MX')} de ${total.toLocaleString('es-MX')}`,
  },
  /** #64: la pantalla no se pudo descargar o tuvo un error inesperado. */
  errorApp: {
    recargando: 'Cargando la versión más reciente…',
    cargaTitulo: 'No se pudo abrir esta pantalla',
    cargaTexto:
      'Puede que se haya ido la conexión o que haya una versión nueva de Uniper Ops. Recarga la página para seguir.',
    genericoTitulo: 'Algo salió mal',
    genericoTexto:
      'La pantalla tuvo un error inesperado. Recarga la página; si se repite, avísale al administrador.',
    recargar: 'Recargar',
  },
  superficies: {
    ops: { titulo: 'Operación' },
    muelle: { titulo: 'Muelle' },
    portal: { titulo: 'Portal de clientes' },
    op: { titulo: 'Mi turno' },
  },
} as const
